webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(17);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueRouter = __webpack_require__(16);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueRx = __webpack_require__(30);
	
	var _vueRx2 = _interopRequireDefault(_vueRx);
	
	var _vueTouch = __webpack_require__(128);
	
	var _vueTouch2 = _interopRequireDefault(_vueTouch);
	
	var _Observable = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(7);
	
	var _App = __webpack_require__(100);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(64);
	
	__webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.$ = __webpack_require__(68);
	
	// mobile stuff..
	
	
	_vue2.default.use(_vueRx2.default, { Observable: _Observable.Observable, Subscription: _Subscription.Subscription });
	_vue2.default.use(_vueTouch2.default);
	
	var app = new _vue2.default(_App2.default);
	app.$mount('app'
	
	// Inject webpack's livereload script, when it's not embedded into the bundle but the dev-server is running.
	);if (false) {
	    var s = document.createElement('script');
	    s.async = true;
	    s.src = 'http://localhost:8080/webpack-dev-server.js';
	    document.head.appendChild(s);
	}

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var episodes = exports.episodes = [
	// episode 1
	{
	    id: 0,
	    title: 'De officier van justitie wordt wakker gebeld.',
	    thumbnail: './images/81.jpg',
	    animation: [{
	        file: './images/65.jpg',
	        type: 'image',
	        text: 'Een koude donkere februari-avond, 23:34',
	        audio: './audio/ThunderRain.mp3'
	    }, {
	        file: './images/71.jpg',
	        type: 'image',
	        text: 'Een eenzame automobilist',
	        audio: ''
	    }, {
	        file: './images/76.jpg',
	        type: 'image',
	        text: 'rijdt door het bos naar huis.',
	        audio: ''
	    }, {
	        file: './images/81.jpg',
	        type: 'image',
	        text: 'Er ligt een man op de weg!',
	        audio: './audio/ThunderRain.mp3'
	    }, {
	        file: './images/86.jpg',
	        type: 'image',
	        text: 'Zijn gezicht is onherkenbaar verminkt.',
	        audio: ''
	    }, {
	        file: './images/91.jpg',
	        type: 'image',
	        text: 'Nog een auto?',
	        audio: './audio/ThunderRain.mp3'
	    }, {
	        file: './images/96.jpg',
	        type: 'image',
	        text: 'De auto nadert snel.',
	        audio: './audio/CarSkid.mp3'
	    }, {
	        file: './images/101.jpg',
	        type: 'image',
	        text: 'De automobilist kan de auto net ontwijken!',
	        audio: './audio/CarSkidBrake.mp3'
	    }, {
	        file: './images/106.jpg',
	        type: 'image',
	        text: 'Hij belt 112.',
	        audio: './audio/ThunderRain.mp3'
	    }, {
	        file: './videos/Openingsscene.mp4',
	        type: 'video'
	    }],
	    introImageText: 'Je hebt nachtdienst (\'piket\').<br>Je wordt gebeld door de politie en er wordt een opsporingsteam geformeerd.',
	    introImage: './images/img-phone.png',
	    introtext: 'Jij bent officier van justitie. Je hebt nachtdienst (\'piket\'). Je wordt gebeld door de politie. Er wordt een opsporingsteam geformeerd. Jij geeft leiding aan het onderzoek. Wat doe je?',
	    actions: [{
	        id: 0,
	        title: 'Aangeven welke sporen veiliggesteld moeten worden. ',
	        answer: true,
	        feedback: 'Ja, het is van het grootste belang dat sporen op de plaats delict snel en nauwkeurig worden veiliggesteld. '
	    }, {
	        id: 1,
	        title: 'Opdracht geven de automobilist die heeft gebeld te horen.',
	        answer: true,
	        feedback: 'Ja, alles wat hij heeft gezien kan van belang zijn. '
	    }, {
	        id: 2,
	        title: 'Toestemming vragen voor een telefoontap aan de rechter-commissaris (de rechter die beslist over welke opsporingsmiddelen ingezet mogen worden).',
	        answer: false,
	        feedback: 'Nee, er is geen telefoon die je zou willen tappen.'
	    }, {
	        id: 3,
	        title: 'Beslag leggen op het lichaam van het slachtoffer. En het Nederlands Forensisch Instituut (NFI) opdracht geven onderzoek te doen naar de doodsoorzaak en eventuele sporen. ',
	        answer: true,
	        feedback: 'Ja, ook al lijkt de doodsoorzaak voor de hand te liggen, je moet het zeker weten. Bovendien kan het NFI zoeken naar sporen van de dader. '
	    }, {
	        id: 4,
	        title: 'Opdracht geven de plaats delict te observeren. ',
	        answer: false,
	        feedback: 'Nee, de dader is gevlucht en de plaats delict is helemaal onderzocht. Er is geen reden om daar verder nog iets te doen. '
	    }, {
	        id: 5,
	        title: 'Opdracht geven voor het doen van buurtonderzoek.',
	        answer: true,
	        feedback: 'Ja, misschien heeft iemand op de tijd van het delict iets gezien of gehoord. '
	    }, {
	        id: 6,
	        title: 'Opsporing Verzocht inschakelen. ',
	        answer: false,
	        feedback: 'Nee,  je bent nog vol in onderzoek. Opsporing Verzocht kun je als dat nodig is later inschakelen als andere opsporingsmiddelen niets hebben opgeleverd.'
	    }]
	},
	// episode 2
	{
	    id: 1,
	    title: 'Plaats delict. ',
	    thumbnail: './images/145.jpg',
	    animation: [{
	        file: './videos/plaatsdelict.mp4',
	        type: 'video'
	    }],
	    introtext: 'De getuige heeft het kenteken van de auto niet kunnen zien. Maar hij heeft wel gezien dat het om een kleine, rode auto gaat met een flinke deuk in de motorkap. De koplampen waren uit. De achterlichten doen hem denken aan een Renault Twingo. Wat doe je?',
	    actions: [{
	        id: 0,
	        title: 'Je laat alle garagehouders in de buurt bellen om te vragen of ze een dergelijke auto  herkennen. ',
	        answer: false,
	        feedback: 'Nee, het is maar de vraag of dit wat oplevert en zo komt de informatie naar buiten die je voorlopig liever binnen het onderzoek houdt. '
	    }, {
	        id: 1,
	        title: 'Je geeft de politie opdracht om in het interne systeem van de politie te zoeken naar een kleine, rode auto met schade aan de motorkap. ',
	        answer: true,
	        feedback: 'Ja, hierdoor komen drie mogelijke auto\'s naar voren. '
	    }]
	},
	// episode 3
	{
	    id: 2,
	    title: 'Het Nederlands Forensisch Instituut',
	    thumbnail: './images/156.jpg',
	    animation: [{
	        file: './images/156.jpg',
	        type: 'image',
	        text: 'Het Nederlands Forensisch Instituut',
	        audio: ''
	    }, {
	        file: './videos/forensisch.mp4',
	        type: 'video'
	    }],
	    introtext: 'Het Nederlands Forensisch Instituut (NFI) rapporteert de doodsoorzaak: excessief geweld op het hoofd met een hol of rond voorwerp. Wat doe je met deze informatie?',
	    actions: [{
	        id: 0,
	        title: 'Je brengt dit in een persbericht naar buiten. Misschien dat iemand het wapen kent. ',
	        answer: false,
	        feedback: 'Nee, zo geef je informatie weg die alleen bij de dader bekend is. '
	    }, {
	        id: 1,
	        title: 'Je houdt dit geheim.',
	        answer: true,
	        feedback: 'Ja, dat is daderinformatie en kan van belang zijn voor de bewijsvoering. '
	    }, {
	        id: 2,
	        title: 'Je geeft het lichaam vrij.',
	        answer: true,
	        feedback: 'Ja, als het NFI-onderzoek is afgerond, beslist de officier van justitie dat het lichaam aan de familie overgedragen kan worden.'
	    }]
	},
	// episode 4
	{
	    id: 3,
	    title: 'Bewijsmateriaal?',
	    thumbnail: './images/169.jpg',
	    animation: [{
	        file: './images/169.jpg',
	        type: 'image',
	        text: 'Bewijsmateriaal?',
	        audio: ''
	    }],
	    introtext: 'Enkele dagen later wordt aangifte gedaan van diefstal van een auto. Het gaat om één van de drie auto\'s die in het onderzoek naar voren zijn gekomen. De auto wordt gevonden, drijvend in een sloot. Wat doe je?',
	    actions: [{
	        id: 0,
	        title: 'Je laat de auto vernietigen.',
	        answer: false,
	        feedback: 'Nee, misschien vernietig je wel sporen.'
	    }, {
	        id: 1,
	        title: 'Je neemt de auto in beslag en geeft opdracht deze op sporen te onderzoeken.',
	        answer: true,
	        feedback: 'Ja, het is het beste om zo snel mogelijk naar sporen te zoeken.'
	    }, {
	        id: 2,
	        title: 'Je neemt de auto in beslag en laat deze ergens opslaan.',
	        answer: false,
	        feedback: 'Nee, als je besluit de auto te bewaren voor onderzoek, dan is het beter dit onderzoek gelijk te doen.'
	    }]
	},
	// episode 5
	{
	    id: 4,
	    title: 'De officier van justitie leidt het onderzoek.',
	    thumbnail: './images/183.jpg',
	    animation: [{
	        file: './images/183.jpg',
	        type: 'image',
	        text: 'De officier van justitie leidt het onderzoek.',
	        audio: ''
	    }],
	    introtext: 'Wat doe je om te weten te komen wie het slachtoffer is?',
	    actions: [{
	        id: 0,
	        title: 'Je laat DNA afnemen.',
	        answer: false,
	        feedback: 'In dit stadium van het onderzoek is het niet nodig om DNA-onderzoek te doen voor het vaststellen van de identiteit.'
	    }, {
	        id: 1,
	        title: 'Je laat de politie nagaan of iemand als vermist is opgegeven die past bij het signalement. ',
	        answer: true,
	        feedback: 'Ja, dit wil vaak helpen. In deze zaak levert het helaas niets op. '
	    }, {
	        id: 2,
	        title: 'Je schakelt opsporingsprogramma’s in waarbij je mensen oproept zich te melden als ze iets verdachts hebben gezien.',
	        answer: false,
	        feedback: 'Nee, soms gebeurt dat maar alleen als alle andere middelen tot niets hebben geleid. '
	    }, {
	        id: 3,
	        title: 'Je laat onderzoek doen naar vingerafdrukken. ',
	        answer: true,
	        feedback: 'Ja, op deze manier komt aan het licht dat het gaat om een man die bij het Leger des Heils woont. Hij is die avond het laatst tussen acht en negen uur thuis gezien. '
	    }]
	},
	// episode 6
	{
	    id: 5,
	    title: 'Overleg met politie. ',
	    thumbnail: './images/202.jpg',
	    animation: [{
	        file: './images/202.jpg',
	        type: 'image',
	        text: 'Overleg met politie. ',
	        audio: ''
	    }],
	    introtext: 'Wat doe je nu bekend is wie het slachtoffer is?',
	    actions: [{
	        id: 0,
	        title: 'Je maakt de identiteit bekend in de hoop dat mensen die hem kennen zich melden. ',
	        answer: false,
	        feedback: 'Nee, er zijn allerlei andere manieren om nu verder te komen in het onderzoek.'
	    }, {
	        id: 1,
	        title: 'Je laat de politie de familie opsporen, zodat ze hem kunnen begraven. ',
	        answer: true,
	        feedback: 'Ja, ook dat hoort bij het werk van de politie. En misschien heeft de familie belangrijke informatie.'
	    }, {
	        id: 1,
	        title: 'Je laat de politie zijn omgeving in beeld brengen en laat vrienden en kennissen horen. ',
	        answer: true,
	        feedback: 'Ja, dit kan nieuwe aanwijzingen opleveren. '
	    }]
	},
	// episode 7
	{
	    id: 6,
	    title: 'Een doorbraak!',
	    thumbnail: './images/218.jpg',
	    animation: [{
	        file: './images/218.jpg',
	        type: 'image',
	        text: 'Een doorbraak!',
	        audio: ''
	    }],
	    introtext: 'Eén van de kennissen van het slachtoffer is ook de eigenaar van één van de drie rode, beschadigde auto\'s. Bovendien kwam die man vaker in het bewuste bos met zijn hond en heeft hij eerder geweld gepleegd. Wat doe je?',
	    actions: [{
	        id: 0,
	        title: 'Je merkt de man aan als verdachte en vraagt de rechter-commissaris om zijn telefoon te tappen.',
	        answer: true,
	        feedback: 'Ja, misschien praat de verdachte via de telefoon over het misdrijf.'
	    }, {
	        id: 1,
	        title: 'Je sluit het onderzoek en stuurt de man een dagvaarding. ',
	        answer: false,
	        feedback: 'Nee, veel te vroeg. Je hebt een verdenking maar nog geen hard bewijs. '
	    }, {
	        id: 2,
	        title: 'Je laat de man aanhouden. ',
	        answer: false,
	        feedback: 'Nee, veel te vroeg. Je hebt een verdenking maar nog geen hard bewijs. '
	    }, {
	        id: 3,
	        title: 'Je schakelt opsporingsprogramma\'s in waarbij je mensen oproept zich te melden als ze iets verdachts hebben gezien.',
	        answer: true,
	        feedback: 'Ja, nog mooier is het als je dit doet in combinatie met tappen. De dader kan na het zien van het programma nerveus worden en mededaders opbellen.'
	    }]
	},
	// episode 8
	{
	    id: 7,
	    title: 'Het bekende tv-programma wordt ingeschakeld. ',
	    thumbnail: './images/231.jpg',
	    animation: [{
	        file: './images/231.jpg',
	        type: 'image',
	        text: 'Het bekende tv-programma wordt ingeschakeld. ',
	        audio: ''
	    }],
	    introtext: 'Er komen tips binnen. Iemand noemt de verdachte en weet van de beschadigde auto. De verdachte belt zelf ook en zegt dat de beste vriend van het slachtoffer het heeft gedaan. Hierbij vertelt hij details die alleen de dader kan weten. Wat doe je?',
	    actions: [{
	        id: 0,
	        title: 'Je laat de verdachte aanhouden en confronteert hem hiermee. ',
	        answer: false,
	        feedback: 'Nee, de zaak wordt wel sterker, maar er is nog te weinig bewijs om de verdachte vast te kunnen houden. Het onderzoek moet verder om meer bewijs te vinden. '
	    }, {
	        id: 1,
	        title: 'Je laat de verdachte niet aanhouden, maar je geeft de politie wel de opdracht dit allemaal nauwkeurig vast te leggen en te bewaren. ',
	        answer: true,
	        feedback: 'Ja, je weet dat dit van groot belang zal zijn. '
	    }]
	},
	// episode 9
	{
	    id: 8,
	    title: 'Getuigen melden zich. ',
	    thumbnail: './images/242.jpg',
	    animation: [{
	        file: './images/242.jpg',
	        type: 'image',
	        text: 'Getuigen melden zich. ',
	        audio: ''
	    }],
	    introtext: 'Twee kennissen van zowel het slachtoffer als de verdachte die eerder niets wilden vertellen melden zich op het bureau. Beiden staan bekend als alcoholist. Zij vertellen dat de verdachte op de avond van de moord bij hen was en om kwart voor tien weg ging met een ijzeren staaf. Later was hij met bebloede handen en zonder die ijzeren staaf teruggekomen. Hij had gezegd dat hij de verkrachter van zijn kinderen had doodgeslagen. De volgende dag maakte hij zijn auto grondig schoon. Wat doe je?',
	    actions: [{
	        id: 0,
	        title: 'Je laat de verdachte aanhouden. ',
	        answer: true,
	        feedback: 'Ja, er is nu voldoende bewijs om de man niet alleen aan te houden maar ook voor te geleiden bij de rechter-commissaris. Die beslist of de man na drie dagen bij de politie langer vast moet zitten, in voorarrest. Als er te weinig bewijs is, komt hij weer vrij en dan is er vluchtgevaar. '
	    }, {
	        id: 1,
	        title: 'Je laat de verdachte observeren.',
	        answer: false,
	        feedback: 'Nee, je hebt nu wel voldoende bewijs om hem aan te houden. Observeren zou een verspilling zijn. '
	    }, {
	        id: 2,
	        title: 'Je zoekt meer ondersteuning voor deze verklaring.',
	        answer: true,
	        feedback: 'Ja, dat is wel nodig. De advocaat van de verdachte vindt de verklaring van de twee kennissen te onbetrouwbaar omdat de mannen verslaafd zijn aan alcohol. '
	    }]
	},
	// episode 10
	{
	    id: 9,
	    title: 'De zitting.',
	    thumbnail: './images/255.jpg',
	    animation: [{
	        file: './videos/aanhoudingen.mp4',
	        type: 'video'
	    }, {
	        file: './images/255.jpg',
	        type: 'image',
	        text: 'De zitting. ',
	        audio: ''
	    }],
	    introtext: 'Je hebt de verdachte gedagvaard. Hij moet dus voor de rechter verschijnen. Welk bewijs voer je tegen hem op?',
	    actions: [{
	        id: 0,
	        title: 'De verklaring van de twee kennissen. ',
	        answer: true,
	        feedback: 'Ja, de advocaat kan dan wel zeggen dat de verklaring niet betrouwbaar is, de mannen zijn uit eigen initiatief met het verhaal gekomen. '
	    }, {
	        id: 1,
	        title: 'De gegevens uit het technisch onderzoek over de auto.',
	        answer: true,
	        feedback: 'Ja, en dit in combinatie met de verklaring van de automobilist.'
	    }, {
	        id: 2,
	        title: 'De verklaring van de verdachte zelf.',
	        answer: true,
	        feedback: 'Ja waarbij het wel zo is dat de verdachte geen antwoord hoeft te geven op de vragen die hem gesteld worden.'
	    }, {
	        id: 3,
	        title: 'De tapgesprekken.',
	        answer: true,
	        feedback: 'Ja, hierbij kan het om zowel belastend als ontlastend materiaal gaan. In de taps in deze zaak zegt de verdachte tegen een kennis dat er "een beloning op mijn kop" staat en ook bekent hij te hebben geslagen met een ijzeren staaf.'
	    }]
	},
	// episode 11
	{
	    id: 10,
	    title: 'Pieter Baan Centrum onderzoekt.',
	    thumbnail: './images/270.jpg',
	    animation: [{
	        file: './images/270.jpg',
	        type: 'image',
	        text: 'Pieter Baan Centrum onderzoekt.',
	        audio: ''
	    }],
	    introtext: 'Je hebt de rechtbank gevraagd om de man psychisch te laten onderzoeken in het Pieter Baan Centrum. Het doel is om te weten te komen of de man geheel of verminderd toerekeningsvatbaar is. Het Pieter Baan Centrum stelt vast dat de man een persoonlijkheidsstoornis heeft en verminderd toerekeningsvatbaar is. De maximale straf voor moord is levenslang. Welke straf vind je passend?',
	    actions: [{
	        id: 0,
	        title: 'Een taakstraf met verplichte bezoeken aan de reclassering.',
	        answer: false,
	        feedback: 'Nee, dit is een te lage straf volgens het OM.'
	    }, {
	        id: 1,
	        title: 'Een gevangenisstraf van zes jaar en tbs met dwangverpleging.',
	        answer: true,
	        feedback: 'Ja, dit is mogelijk, in hoger beroep is de verdachte hiertoe door het Gerechtshof veroordeeld. '
	    }, {
	        id: 2,
	        title: 'Acht jaar gevangenisstraf en tbs met dwangverpleging.',
	        answer: true,
	        feedback: 'Ja, de man moet volgens het OM niet alleen een gevangenisstraf krijgen maar ook behandeld worden voor zijn psychische problemen. '
	    }, {
	        id: 3,
	        title: 'Een gevangenisstraf van 35 jaar.',
	        answer: false,
	        feedback: 'Nee, na levenslang is 30 jaar de hoogste gevangenisstraf die iemand kan krijgen.'
	    }, {
	        id: 4,
	        title: 'Een levenslange gevangenisstraf.',
	        answer: false,
	        feedback: 'Nee, levenslang wordt niet zo vaak geëist. In dit geval telt mee dat de man een persoonlijkheidsstoornis heeft. '
	    }]
	}];
	
	var endtexts = exports.endtexts = [{
	    id: 0,
	    header: 'Helaas',
	    text: 'Je bent nog niet echt een goede speurneus. De kans is klein dat jij in dit geval de juiste dader achter slot en grendel had gekregen. Wil je meer weten over het werk van de officier van justitie kijk dan eens op <a href="https://www.om.nl" target="_BLANK">www.om.nl</a> en volg het OM op <a href="https://www.facebook.com/OpenbaarMinisterie/" target="_BLANK">www.facebook.com/OpenbaarMinisterie</a>',
	    video: './videos/Slechtescore.mp4'
	}, {
	    id: 1,
	    header: 'Gefeliciteerd',
	    text: 'Je hebt het speurwerk wel in de vingers, maar maakt af en toe een fout. En dat kan er zomaar voor zorgen dat de dader ontkomt of dat het bewijs niet geldig is in de rechtszaal. Verdiep je anders eens in het werk van de officier op <a href="https://www.om.nl" target="_BLANK">www.om.nl</a> en volg het OM op <a href="https://www.facebook.com/OpenbaarMinisterie/" target="_BLANK">www.facebook.com/OpenbaarMinisterie</a>',
	    video: './videos/Matigescore.mp4'
	}, {
	    id: 2,
	    header: 'Gefeliciteerd',
	    text: 'Heel goed gedaan, misdadigers zijn niet veilig wanneer jij de leiding hebt over het opsporingsonderzoek! Je zou een goede officier van justitie zijn. Kijk voor meer informatie op <a href="https://www.om.nl" target="_BLANK">www.om.nl</a> en volg het OM op <a href="https://www.facebook.com/OpenbaarMinisterie/" target="_BLANK">www.facebook.com/OpenbaarMinisterie</a>',
	    video: './videos/Goedescore.mp4'
	}];

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var config = exports.config = {
	    increment: 10,
	    decrement: 0,
	    true: 'Doen',
	    false: 'Niet doen'
	};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	//---Custom Eases---//
	
	// include CustomEase.min.js for this to work //
	
	//--- BUZZ ---//
	// used for a vibrating phone effect //
	CustomEase.create("buzz", "M0,0 C0.098,0 0,1.3 0.1,1.3 0.198,1.3 0.102,0 0.2,0 0.292,0 0.202,1.3 0.3,1.3 0.404,1.3 0.304,0 0.4,0 0.496,0 0.402,1.3 0.5,1.3 0.604,1.3 0.506,0 0.6,0 0.692,0 0.602,1.3 0.7,1.3 0.798,1.3 0.698,0 0.8,0 0.896,0 0.804,1.3 0.9,1.3 1,1.3 0.906,0 1,0");
	
	//---BLINK---//
	// used for a button grow / rotate to attract attention //
	CustomEase.create("blink", "M0,0 C0.250,0 0,1 0.250,1 0.5,1 0.250,0 0.5,0 0.750,0 0.5,1 0.750,1 1,1 0.750,0 1,0");
	
	CustomEase.create("bg-wiggle", "M0,0 C0.102,0 0.094,1 0.2,1 0.298,1 0.256,0 0.354,0 0.446,0 0.402,1 0.5,1 0.604,1 0.558,0 0.654,0 0.75,0 0.702,1 0.8,1 0.904,1 0.906,0 1,0");
	
	CustomEase.create("glow", "M0,0 C0.2,0 0.3,1 0.5,1 0.7,1 0.9,0 1,0");

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(17);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _data = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default
	
	// Import app data and config
	);
	
	// Initial state
	var state = {
	    debugmode: 0,
	    game: {
	        episodes: {},
	        episode: 0,
	        action: 0
	    },
	    carousel: {
	        show: false,
	        active: 0
	    }
	
	    // Populate state episodes
	};populateEpisodes();
	function populateEpisodes() {
	    for (var episode in _data.episodes) {
	        state.game.episodes[episode] = _data.episodes[episode];
	        state.game.episodes[episode].locked = true;
	        resetEpisode(episode);
	    }
	}
	
	function resetEpisode(episode) {
	    state.game.episodes[episode].points = 0;
	    state.game.episodes[episode].answers = [];
	    state.game.action = 0;
	}
	
	// Actions
	var actions = {
	    ENABLE_DEBUGMODE: function ENABLE_DEBUGMODE(_ref) {
	        var commit = _ref.commit;
	
	        return new Promise(function (resolve, reject) {
	            for (var episode in state.game.episodes) {
	                commit('UNLOCK_EPISODE', { episode: episode });
	            }
	            commit('ENABLE_DEBUGMODE');
	            resolve();
	        });
	    },
	
	    RESET_GAME: function RESET_GAME(_ref2) {
	        var commit = _ref2.commit;
	
	        return new Promise(function (resolve, reject) {
	            commit('RESET_GAME');
	            resolve();
	        });
	    },
	
	    ADD_ANSWER: function ADD_ANSWER(_ref3, _ref4) {
	        var commit = _ref3.commit;
	        var answer = _ref4.answer;
	
	        commit('ADD_ANSWER', { answer: answer });
	    },
	    RESET_EPISODE: function RESET_EPISODE(_ref5, _ref6) {
	        var commit = _ref5.commit;
	        var episode = _ref6.episode;
	
	        if (_data.episodes[episode]) {
	            commit('RESET_EPISODE', { episode: episode });
	        }
	    },
	
	    CHANGE_EPISODE: function CHANGE_EPISODE(_ref7, _ref8) {
	        var commit = _ref7.commit;
	        var episode = _ref8.episode;
	
	        if (_data.episodes[episode]) {
	            commit('CHANGE_EPISODE', { episode: episode });
	        }
	    },
	    UNLOCK_EPISODE: function UNLOCK_EPISODE(_ref9, _ref10) {
	        var commit = _ref9.commit;
	        var episode = _ref10.episode;
	
	        return new Promise(function (resolve, reject) {
	            if (_data.episodes[episode]) {
	                commit('UNLOCK_EPISODE', { episode: episode });
	            }
	            resolve();
	        });
	    },
	    LOCK_EPISODE: function LOCK_EPISODE(_ref11, _ref12) {
	        var commit = _ref11.commit;
	        var episode = _ref12.episode;
	
	        return new Promise(function (resolve, reject) {
	            if (_data.episodes[episode]) {
	                commit('LOCK_EPISODE', { episode: episode });
	            }
	            resolve();
	        });
	    },
	
	    NEXT_ACTION: function NEXT_ACTION(_ref13) {
	        var commit = _ref13.commit;
	
	        return new Promise(function (resolve, reject) {
	            if (state.game.action < _data.episodes[state.game.episode].actions.length - 1) {
	                commit('NEXT_ACTION');
	                resolve(true);
	            } else {
	                resolve(false);
	            }
	        });
	    },
	    PREVIOUS_ACTION: function PREVIOUS_ACTION(_ref14) {
	        var commit = _ref14.commit;
	
	        if (state.game.action) {
	            commit('PREVIOUS_ACTION');
	        }
	    },
	    SET_ACTION: function SET_ACTION(_ref15, _ref16) {
	        var commit = _ref15.commit;
	        var action = _ref16.action;
	
	        if (_data.episodes[state.game.episode].actions[action]) {
	            commit('SET_ACTION');
	        }
	    },
	
	    CHANGE_POINTS: function CHANGE_POINTS(_ref17, _ref18) {
	        var commit = _ref17.commit;
	        var points = _ref18.points;
	
	        return new Promise(function (resolve, reject) {
	            commit('CHANGE_POINTS', { points: points });
	            resolve();
	        });
	    },
	
	    SHOW_CAROUSEL: function SHOW_CAROUSEL(_ref19, _ref20) {
	        var commit = _ref19.commit;
	        var active = _ref20.active;
	
	        active = active || 0;
	        state.carousel.active = active;
	        commit('SHOW_CAROUSEL');
	    },
	    HIDE_CAROUSEL: function HIDE_CAROUSEL(_ref21) {
	        var commit = _ref21.commit;
	
	        commit('HIDE_CAROUSEL');
	    },
	    NEXT_CAROUSEL_ITEM: function NEXT_CAROUSEL_ITEM(_ref22) {
	        var commit = _ref22.commit;
	
	        if (state.carousel.active < state.game.episodes[state.game.episode].answers.length - 1) {
	            commit('NEXT_CAROUSEL_ITEM');
	        }
	    },
	    PREVIOUS_CAROUSEL_ITEM: function PREVIOUS_CAROUSEL_ITEM(_ref23) {
	        var commit = _ref23.commit;
	
	        if (state.carousel.active) {
	            commit('PREVIOUS_CAROUSEL_ITEM');
	        }
	    }
	
	    // Mutations
	};var mutations = {
	    ENABLE_DEBUGMODE: function ENABLE_DEBUGMODE(state) {
	        state.debugmode = 1;
	    },
	
	    RESET_GAME: function RESET_GAME(state) {
	        populateEpisodes();
	        state.game.episode = 0;
	    },
	
	    ADD_ANSWER: function ADD_ANSWER(state, payload) {
	        state.game.episodes[state.game.episode].answers.push({
	            episode: payload.answer.episode,
	            action: payload.answer.action,
	            answer: payload.answer.answer,
	            points: payload.answer.points,
	            question: payload.answer.question
	        });
	    },
	    RESET_EPISODE: function RESET_EPISODE(state, _ref24) {
	        var episode = _ref24.episode;
	
	        resetEpisode(episode);
	    },
	
	    CHANGE_EPISODE: function CHANGE_EPISODE(state, _ref25) {
	        var episode = _ref25.episode;
	
	        state.game.episode = episode;
	    },
	    UNLOCK_EPISODE: function UNLOCK_EPISODE(state, _ref26) {
	        var episode = _ref26.episode;
	
	        state.game.episodes[episode].locked = false;
	    },
	    LOCK_EPISODE: function LOCK_EPISODE(state, _ref27) {
	        var episode = _ref27.episode;
	
	        state.game.episodes[episode].locked = true;
	    },
	
	    NEXT_ACTION: function NEXT_ACTION(state) {
	        state.game.action++;
	    },
	    PREVIOUS_ACTION: function PREVIOUS_ACTION(state) {
	        state.game.action--;
	    },
	    SET_ACTION: function SET_ACTION(state, _ref28) {
	        var action = _ref28.action;
	
	        state.game.action = action;
	    },
	
	    CHANGE_POINTS: function CHANGE_POINTS(state, _ref29) {
	        var points = _ref29.points;
	
	        if (points < 0) {
	            state.game.episodes[state.game.episode].points -= Math.abs(points);
	        } else {
	            state.game.episodes[state.game.episode].points += points;
	        }
	    },
	
	    SHOW_CAROUSEL: function SHOW_CAROUSEL(state) {
	        state.carousel.show = true;
	    },
	    HIDE_CAROUSEL: function HIDE_CAROUSEL(state) {
	        state.carousel.show = false;
	    },
	    NEXT_CAROUSEL_ITEM: function NEXT_CAROUSEL_ITEM(state) {
	        state.carousel.active++;
	    },
	    PREVIOUS_CAROUSEL_ITEM: function PREVIOUS_CAROUSEL_ITEM(state) {
	        state.carousel.active--;
	    }
	};
	
	var store = new _vuex2.default.Store({
	    state: state,
	    mutations: mutations,
	    actions: actions
	});
	
	exports.default = store;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 *  howler.js v2.0.3
	 *  howlerjs.com
	 *
	 *  (c) 2013-2017, James Simpson of GoldFire Studios
	 *  goldfirestudios.com
	 *
	 *  MIT License
	 */
	
	(function() {
	
	  'use strict';
	
	  /** Global Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create the global controller. All contained methods and properties apply
	   * to all sounds that are currently playing or will be in the future.
	   */
	  var HowlerGlobal = function() {
	    this.init();
	  };
	  HowlerGlobal.prototype = {
	    /**
	     * Initialize the global Howler object.
	     * @return {Howler}
	     */
	    init: function() {
	      var self = this || Howler;
	
	      // Create a global ID counter.
	      self._counter = 0;
	
	      // Internal properties.
	      self._codecs = {};
	      self._howls = [];
	      self._muted = false;
	      self._volume = 1;
	      self._canPlayEvent = 'canplaythrough';
	      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;
	
	      // Public properties.
	      self.masterGain = null;
	      self.noAudio = false;
	      self.usingWebAudio = true;
	      self.autoSuspend = true;
	      self.ctx = null;
	
	      // Set to false to disable the auto iOS enabler.
	      self.mobileAutoEnable = true;
	
	      // Setup the various state values for global tracking.
	      self._setup();
	
	      return self;
	    },
	
	    /**
	     * Get/set the global volume for all sounds.
	     * @param  {Float} vol Volume from 0.0 to 1.0.
	     * @return {Howler/Float}     Returns self or current volume.
	     */
	    volume: function(vol) {
	      var self = this || Howler;
	      vol = parseFloat(vol);
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!self.ctx) {
	        setupAudioContext();
	      }
	
	      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
	        self._volume = vol;
	
	        // Don't update any of the nodes if we are muted.
	        if (self._muted) {
	          return self;
	        }
	
	        // When using Web Audio, we just need to adjust the master gain.
	        if (self.usingWebAudio) {
	          self.masterGain.gain.value = vol;
	        }
	
	        // Loop through and change volume for all HTML5 audio nodes.
	        for (var i=0; i<self._howls.length; i++) {
	          if (!self._howls[i]._webAudio) {
	            // Get all of the sounds in this Howl group.
	            var ids = self._howls[i]._getSoundIds();
	
	            // Loop through all sounds and change the volumes.
	            for (var j=0; j<ids.length; j++) {
	              var sound = self._howls[i]._soundById(ids[j]);
	
	              if (sound && sound._node) {
	                sound._node.volume = sound._volume * vol;
	              }
	            }
	          }
	        }
	
	        return self;
	      }
	
	      return self._volume;
	    },
	
	    /**
	     * Handle muting and unmuting globally.
	     * @param  {Boolean} muted Is muted or not.
	     */
	    mute: function(muted) {
	      var self = this || Howler;
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!self.ctx) {
	        setupAudioContext();
	      }
	
	      self._muted = muted;
	
	      // With Web Audio, we just need to mute the master gain.
	      if (self.usingWebAudio) {
	        self.masterGain.gain.value = muted ? 0 : self._volume;
	      }
	
	      // Loop through and mute all HTML5 Audio nodes.
	      for (var i=0; i<self._howls.length; i++) {
	        if (!self._howls[i]._webAudio) {
	          // Get all of the sounds in this Howl group.
	          var ids = self._howls[i]._getSoundIds();
	
	          // Loop through all sounds and mark the audio node as muted.
	          for (var j=0; j<ids.length; j++) {
	            var sound = self._howls[i]._soundById(ids[j]);
	
	            if (sound && sound._node) {
	              sound._node.muted = (muted) ? true : sound._muted;
	            }
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Unload and destroy all currently loaded Howl objects.
	     * @return {Howler}
	     */
	    unload: function() {
	      var self = this || Howler;
	
	      for (var i=self._howls.length-1; i>=0; i--) {
	        self._howls[i].unload();
	      }
	
	      // Create a new AudioContext to make sure it is fully reset.
	      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
	        self.ctx.close();
	        self.ctx = null;
	        setupAudioContext();
	      }
	
	      return self;
	    },
	
	    /**
	     * Check for codec support of specific extension.
	     * @param  {String} ext Audio file extention.
	     * @return {Boolean}
	     */
	    codecs: function(ext) {
	      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
	    },
	
	    /**
	     * Setup various state values for global tracking.
	     * @return {Howler}
	     */
	    _setup: function() {
	      var self = this || Howler;
	
	      // Keeps track of the suspend/resume state of the AudioContext.
	      self.state = self.ctx ? self.ctx.state || 'running' : 'running';
	
	      // Automatically begin the 30-second suspend process
	      self._autoSuspend();
	
	      // Check if audio is available.
	      if (!self.usingWebAudio) {
	        // No audio is available on this system if noAudio is set to true.
	        if (typeof Audio !== 'undefined') {
	          try {
	            var test = new Audio();
	
	            // Check if the canplaythrough event is available.
	            if (typeof test.oncanplaythrough === 'undefined') {
	              self._canPlayEvent = 'canplay';
	            }
	          } catch(e) {
	            self.noAudio = true;
	          }
	        } else {
	          self.noAudio = true;
	        }
	      }
	
	      // Test to make sure audio isn't disabled in Internet Explorer.
	      try {
	        var test = new Audio();
	        if (test.muted) {
	          self.noAudio = true;
	        }
	      } catch (e) {}
	
	      // Check for supported codecs.
	      if (!self.noAudio) {
	        self._setupCodecs();
	      }
	
	      return self;
	    },
	
	    /**
	     * Check for browser support for various codecs and cache the results.
	     * @return {Howler}
	     */
	    _setupCodecs: function() {
	      var self = this || Howler;
	      var audioTest = null;
	
	      // Must wrap in a try/catch because IE11 in server mode throws an error.
	      try {
	        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
	      } catch (err) {
	        return self;
	      }
	
	      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
	        return self;
	      }
	
	      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');
	
	      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
	      var checkOpera = self._navigator && self._navigator.userAgent.match(/OPR\/([0-6].)/g);
	      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);
	
	      self._codecs = {
	        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
	        mpeg: !!mpegTest,
	        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
	        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
	        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
	        wav: !!audioTest.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ''),
	        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
	        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
	        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
	        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
	        weba: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
	        webm: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
	        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
	        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
	      };
	
	      return self;
	    },
	
	    /**
	     * Mobile browsers will only allow audio to be played after a user interaction.
	     * Attempt to automatically unlock audio on the first user interaction.
	     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
	     * @return {Howler}
	     */
	    _enableMobileAudio: function() {
	      var self = this || Howler;
	
	      // Only run this on mobile devices if audio isn't already eanbled.
	      var isMobile = /iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(self._navigator && self._navigator.userAgent);
	      var isTouch = !!(('ontouchend' in window) || (self._navigator && self._navigator.maxTouchPoints > 0) || (self._navigator && self._navigator.msMaxTouchPoints > 0));
	      if (self._mobileEnabled || !self.ctx || (!isMobile && !isTouch)) {
	        return;
	      }
	
	      self._mobileEnabled = false;
	
	      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
	      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
	      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
	      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
	        self._mobileUnloaded = true;
	        self.unload();
	      }
	
	      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
	      // http://stackoverflow.com/questions/24119684
	      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
	
	      // Call this method on touch start to create and play a buffer,
	      // then check if the audio actually played to determine if
	      // audio has now been unlocked on iOS, Android, etc.
	      var unlock = function() {
	        // Create an empty buffer.
	        var source = self.ctx.createBufferSource();
	        source.buffer = self._scratchBuffer;
	        source.connect(self.ctx.destination);
	
	        // Play the empty buffer.
	        if (typeof source.start === 'undefined') {
	          source.noteOn(0);
	        } else {
	          source.start(0);
	        }
	
	        // Setup a timeout to check that we are unlocked on the next event loop.
	        source.onended = function() {
	          source.disconnect(0);
	
	          // Update the unlocked state and prevent this check from happening again.
	          self._mobileEnabled = true;
	          self.mobileAutoEnable = false;
	
	          // Remove the touch start listener.
	          document.removeEventListener('touchend', unlock, true);
	        };
	      };
	
	      // Setup a touch start listener to attempt an unlock in.
	      document.addEventListener('touchend', unlock, true);
	
	      return self;
	    },
	
	    /**
	     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
	     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
	     * @return {Howler}
	     */
	    _autoSuspend: function() {
	      var self = this;
	
	      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
	        return;
	      }
	
	      // Check if any sounds are playing.
	      for (var i=0; i<self._howls.length; i++) {
	        if (self._howls[i]._webAudio) {
	          for (var j=0; j<self._howls[i]._sounds.length; j++) {
	            if (!self._howls[i]._sounds[j]._paused) {
	              return self;
	            }
	          }
	        }
	      }
	
	      if (self._suspendTimer) {
	        clearTimeout(self._suspendTimer);
	      }
	
	      // If no sound has played after 30 seconds, suspend the context.
	      self._suspendTimer = setTimeout(function() {
	        if (!self.autoSuspend) {
	          return;
	        }
	
	        self._suspendTimer = null;
	        self.state = 'suspending';
	        self.ctx.suspend().then(function() {
	          self.state = 'suspended';
	
	          if (self._resumeAfterSuspend) {
	            delete self._resumeAfterSuspend;
	            self._autoResume();
	          }
	        });
	      }, 30000);
	
	      return self;
	    },
	
	    /**
	     * Automatically resume the Web Audio AudioContext when a new sound is played.
	     * @return {Howler}
	     */
	    _autoResume: function() {
	      var self = this;
	
	      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
	        return;
	      }
	
	      if (self.state === 'running' && self._suspendTimer) {
	        clearTimeout(self._suspendTimer);
	        self._suspendTimer = null;
	      } else if (self.state === 'suspended') {
	        self.state = 'resuming';
	        self.ctx.resume().then(function() {
	          self.state = 'running';
	
	          // Emit to all Howls that the audio has resumed.
	          for (var i=0; i<self._howls.length; i++) {
	            self._howls[i]._emit('resume');
	          }
	        });
	
	        if (self._suspendTimer) {
	          clearTimeout(self._suspendTimer);
	          self._suspendTimer = null;
	        }
	      } else if (self.state === 'suspending') {
	        self._resumeAfterSuspend = true;
	      }
	
	      return self;
	    }
	  };
	
	  // Setup the global audio controller.
	  var Howler = new HowlerGlobal();
	
	  /** Group Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create an audio group controller.
	   * @param {Object} o Passed in properties for this group.
	   */
	  var Howl = function(o) {
	    var self = this;
	
	    // Throw an error if no source is provided.
	    if (!o.src || o.src.length === 0) {
	      console.error('An array of source files must be passed with any new Howl.');
	      return;
	    }
	
	    self.init(o);
	  };
	  Howl.prototype = {
	    /**
	     * Initialize a new Howl group object.
	     * @param  {Object} o Passed in properties for this group.
	     * @return {Howl}
	     */
	    init: function(o) {
	      var self = this;
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!Howler.ctx) {
	        setupAudioContext();
	      }
	
	      // Setup user-defined default properties.
	      self._autoplay = o.autoplay || false;
	      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
	      self._html5 = o.html5 || false;
	      self._muted = o.mute || false;
	      self._loop = o.loop || false;
	      self._pool = o.pool || 5;
	      self._preload = (typeof o.preload === 'boolean') ? o.preload : true;
	      self._rate = o.rate || 1;
	      self._sprite = o.sprite || {};
	      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
	      self._volume = o.volume !== undefined ? o.volume : 1;
	
	      // Setup all other default properties.
	      self._duration = 0;
	      self._state = 'unloaded';
	      self._sounds = [];
	      self._endTimers = {};
	      self._queue = [];
	
	      // Setup event listeners.
	      self._onend = o.onend ? [{fn: o.onend}] : [];
	      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
	      self._onload = o.onload ? [{fn: o.onload}] : [];
	      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
	      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
	      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
	      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
	      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
	      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
	      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
	      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
	      self._onresume = [];
	
	      // Web Audio or HTML5 Audio?
	      self._webAudio = Howler.usingWebAudio && !self._html5;
	
	      // Automatically try to enable audio on iOS.
	      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.mobileAutoEnable) {
	        Howler._enableMobileAudio();
	      }
	
	      // Keep track of this Howl group in the global controller.
	      Howler._howls.push(self);
	
	      // If they selected autoplay, add a play event to the load queue.
	      if (self._autoplay) {
	        self._queue.push({
	          event: 'play',
	          action: function() {
	            self.play();
	          }
	        });
	      }
	
	      // Load the source file unless otherwise specified.
	      if (self._preload) {
	        self.load();
	      }
	
	      return self;
	    },
	
	    /**
	     * Load the audio file.
	     * @return {Howler}
	     */
	    load: function() {
	      var self = this;
	      var url = null;
	
	      // If no audio is available, quit immediately.
	      if (Howler.noAudio) {
	        self._emit('loaderror', null, 'No audio support.');
	        return;
	      }
	
	      // Make sure our source is in an array.
	      if (typeof self._src === 'string') {
	        self._src = [self._src];
	      }
	
	      // Loop through the sources and pick the first one that is compatible.
	      for (var i=0; i<self._src.length; i++) {
	        var ext, str;
	
	        if (self._format && self._format[i]) {
	          // If an extension was specified, use that instead.
	          ext = self._format[i];
	        } else {
	          // Make sure the source is a string.
	          str = self._src[i];
	          if (typeof str !== 'string') {
	            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
	            continue;
	          }
	
	          // Extract the file extension from the URL or base64 data URI.
	          ext = /^data:audio\/([^;,]+);/i.exec(str);
	          if (!ext) {
	            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
	          }
	
	          if (ext) {
	            ext = ext[1].toLowerCase();
	          }
	        }
	
	        // Log a warning if no extension was found.
	        if (!ext) {
	          console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
	        }
	
	        // Check if this extension is available.
	        if (ext && Howler.codecs(ext)) {
	          url = self._src[i];
	          break;
	        }
	      }
	
	      if (!url) {
	        self._emit('loaderror', null, 'No codec support for selected audio sources.');
	        return;
	      }
	
	      self._src = url;
	      self._state = 'loading';
	
	      // If the hosting page is HTTPS and the source isn't,
	      // drop down to HTML5 Audio to avoid Mixed Content errors.
	      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
	        self._html5 = true;
	        self._webAudio = false;
	      }
	
	      // Create a new sound object and add it to the pool.
	      new Sound(self);
	
	      // Load and decode the audio data for playback.
	      if (self._webAudio) {
	        loadBuffer(self);
	      }
	
	      return self;
	    },
	
	    /**
	     * Play a sound or resume previous playback.
	     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
	     * @param  {Boolean} internal Internal Use: true prevents event firing.
	     * @return {Number}          Sound ID.
	     */
	    play: function(sprite, internal) {
	      var self = this;
	      var id = null;
	
	      // Determine if a sprite, sound id or nothing was passed
	      if (typeof sprite === 'number') {
	        id = sprite;
	        sprite = null;
	      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
	        // If the passed sprite doesn't exist, do nothing.
	        return null;
	      } else if (typeof sprite === 'undefined') {
	        // Use the default sound sprite (plays the full audio length).
	        sprite = '__default';
	
	        // Check if there is a single paused sound that isn't ended.
	        // If there is, play that sound. If not, continue as usual.
	        var num = 0;
	        for (var i=0; i<self._sounds.length; i++) {
	          if (self._sounds[i]._paused && !self._sounds[i]._ended) {
	            num++;
	            id = self._sounds[i]._id;
	          }
	        }
	
	        if (num === 1) {
	          sprite = null;
	        } else {
	          id = null;
	        }
	      }
	
	      // Get the selected node, or get one from the pool.
	      var sound = id ? self._soundById(id) : self._inactiveSound();
	
	      // If the sound doesn't exist, do nothing.
	      if (!sound) {
	        return null;
	      }
	
	      // Select the sprite definition.
	      if (id && !sprite) {
	        sprite = sound._sprite || '__default';
	      }
	
	      // If we have no sprite and the sound hasn't loaded, we must wait
	      // for the sound to load to get our audio's duration.
	      if (self._state !== 'loaded' && !self._sprite[sprite]) {
	        self._queue.push({
	          event: 'play',
	          action: function() {
	            self.play(self._soundById(sound._id) ? sound._id : undefined);
	          }
	        });
	
	        return sound._id;
	      }
	
	      // Don't play the sound if an id was passed and it is already playing.
	      if (id && !sound._paused) {
	        // Trigger the play event, in order to keep iterating through queue.
	        if (!internal) {
	          setTimeout(function() {
	            self._emit('play', sound._id);
	          }, 0);
	        }
	
	        return sound._id;
	      }
	
	      // Make sure the AudioContext isn't suspended, and resume it if it is.
	      if (self._webAudio) {
	        Howler._autoResume();
	      }
	
	      // Determine how long to play for and where to start playing.
	      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
	      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
	      var timeout = (duration * 1000) / Math.abs(sound._rate);
	
	      // Update the parameters of the sound
	      sound._paused = false;
	      sound._ended = false;
	      sound._sprite = sprite;
	      sound._seek = seek;
	      sound._start = self._sprite[sprite][0] / 1000;
	      sound._stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
	      sound._loop = !!(sound._loop || self._sprite[sprite][2]);
	
	      // Begin the actual playback.
	      var node = sound._node;
	      if (self._webAudio) {
	        // Fire this when the sound is ready to play to begin Web Audio playback.
	        var playWebAudio = function() {
	          self._refreshBuffer(sound);
	
	          // Setup the playback params.
	          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
	          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
	          sound._playStart = Howler.ctx.currentTime;
	
	          // Play the sound using the supported method.
	          if (typeof node.bufferSource.start === 'undefined') {
	            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
	          } else {
	            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
	          }
	
	          // Start a new timer if none is present.
	          if (timeout !== Infinity) {
	            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	          }
	
	          if (!internal) {
	            setTimeout(function() {
	              self._emit('play', sound._id);
	            }, 0);
	          }
	        };
	
	        var isRunning = (Howler.state === 'running');
	        if (self._state === 'loaded' && isRunning) {
	          playWebAudio();
	        } else {
	          // Wait for the audio to load and then begin playback.
	          var event = !isRunning && self._state === 'loaded' ? 'resume' : 'load';
	          self.once(event, playWebAudio, isRunning ? sound._id : null);
	
	          // Cancel the end timer.
	          self._clearTimer(sound._id);
	        }
	      } else {
	        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
	        var playHtml5 = function() {
	          node.currentTime = seek;
	          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
	          node.volume = sound._volume * Howler.volume();
	          node.playbackRate = sound._rate;
	          node.play();
	
	          // Setup the new end timer.
	          if (timeout !== Infinity) {
	            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	          }
	
	          if (!internal) {
	            self._emit('play', sound._id);
	          }
	        };
	
	        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
	        var loadedNoReadyState = (self._state === 'loaded' && (window && window.ejecta || !node.readyState && Howler._navigator.isCocoonJS));
	        if (node.readyState === 4 || loadedNoReadyState) {
	          playHtml5();
	        } else {
	          var listener = function() {
	            // Begin playback.
	            playHtml5();
	
	            // Clear this listener.
	            node.removeEventListener(Howler._canPlayEvent, listener, false);
	          };
	          node.addEventListener(Howler._canPlayEvent, listener, false);
	
	          // Cancel the end timer.
	          self._clearTimer(sound._id);
	        }
	      }
	
	      return sound._id;
	    },
	
	    /**
	     * Pause playback and save current position.
	     * @param  {Number} id The sound ID (empty to pause all in group).
	     * @return {Howl}
	     */
	    pause: function(id) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to pause when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'pause',
	          action: function() {
	            self.pause(id);
	          }
	        });
	
	        return self;
	      }
	
	      // If no id is passed, get all ID's to be paused.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Clear the end timer.
	        self._clearTimer(ids[i]);
	
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound && !sound._paused) {
	          // Reset the seek position.
	          sound._seek = self.seek(ids[i]);
	          sound._rateSeek = 0;
	          sound._paused = true;
	
	          // Stop currently running fades.
	          self._stopFade(ids[i]);
	
	          if (sound._node) {
	            if (self._webAudio) {
	              // make sure the sound has been created
	              if (!sound._node.bufferSource) {
	                return self;
	              }
	
	              if (typeof sound._node.bufferSource.stop === 'undefined') {
	                sound._node.bufferSource.noteOff(0);
	              } else {
	                sound._node.bufferSource.stop(0);
	              }
	
	              // Clean up the buffer source.
	              self._cleanBuffer(sound._node);
	            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
	              sound._node.pause();
	            }
	          }
	        }
	
	        // Fire the pause event, unless `true` is passed as the 2nd argument.
	        if (!arguments[1]) {
	          self._emit('pause', sound ? sound._id : null);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Stop playback and reset to start.
	     * @param  {Number} id The sound ID (empty to stop all in group).
	     * @param  {Boolean} internal Internal Use: true prevents event firing.
	     * @return {Howl}
	     */
	    stop: function(id, internal) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to stop when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'stop',
	          action: function() {
	            self.stop(id);
	          }
	        });
	
	        return self;
	      }
	
	      // If no id is passed, get all ID's to be stopped.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Clear the end timer.
	        self._clearTimer(ids[i]);
	
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound) {
	          // Reset the seek position.
	          sound._seek = sound._start || 0;
	          sound._rateSeek = 0;
	          sound._paused = true;
	          sound._ended = true;
	
	          // Stop currently running fades.
	          self._stopFade(ids[i]);
	
	          if (sound._node) {
	            if (self._webAudio) {
	              // make sure the sound has been created
	              if (!sound._node.bufferSource) {
	                if (!internal) {
	                  self._emit('stop', sound._id);
	                }
	
	                return self;
	              }
	
	              if (typeof sound._node.bufferSource.stop === 'undefined') {
	                sound._node.bufferSource.noteOff(0);
	              } else {
	                sound._node.bufferSource.stop(0);
	              }
	
	              // Clean up the buffer source.
	              self._cleanBuffer(sound._node);
	            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
	              sound._node.currentTime = sound._start || 0;
	              sound._node.pause();
	            }
	          }
	        }
	
	        if (sound && !internal) {
	          self._emit('stop', sound._id);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Mute/unmute a single sound or all sounds in this Howl group.
	     * @param  {Boolean} muted Set to true to mute and false to unmute.
	     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
	     * @return {Howl}
	     */
	    mute: function(muted, id) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to mute when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'mute',
	          action: function() {
	            self.mute(muted, id);
	          }
	        });
	
	        return self;
	      }
	
	      // If applying mute/unmute to all sounds, update the group's value.
	      if (typeof id === 'undefined') {
	        if (typeof muted === 'boolean') {
	          self._muted = muted;
	        } else {
	          return self._muted;
	        }
	      }
	
	      // If no id is passed, get all ID's to be muted.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound) {
	          sound._muted = muted;
	
	          if (self._webAudio && sound._node) {
	            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
	          } else if (sound._node) {
	            sound._node.muted = Howler._muted ? true : muted;
	          }
	
	          self._emit('mute', sound._id);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
	     *   volume() -> Returns the group's volume value.
	     *   volume(id) -> Returns the sound id's current volume.
	     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
	     *   volume(vol, id) -> Sets the volume of passed sound id.
	     * @return {Howl/Number} Returns self or current volume.
	     */
	    volume: function() {
	      var self = this;
	      var args = arguments;
	      var vol, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // Return the value of the groups' volume.
	        return self._volume;
	      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
	        // First check if this is an ID, and if not, assume it is a new volume.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else {
	          vol = parseFloat(args[0]);
	        }
	      } else if (args.length >= 2) {
	        vol = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // Update the volume or return the current volume.
	      var sound;
	      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
	        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
	        if (self._state !== 'loaded') {
	          self._queue.push({
	            event: 'volume',
	            action: function() {
	              self.volume.apply(self, args);
	            }
	          });
	
	          return self;
	        }
	
	        // Set the group volume.
	        if (typeof id === 'undefined') {
	          self._volume = vol;
	        }
	
	        // Update one or all volumes.
	        id = self._getSoundIds(id);
	        for (var i=0; i<id.length; i++) {
	          // Get the sound.
	          sound = self._soundById(id[i]);
	
	          if (sound) {
	            sound._volume = vol;
	
	            // Stop currently running fades.
	            if (!args[2]) {
	              self._stopFade(id[i]);
	            }
	
	            if (self._webAudio && sound._node && !sound._muted) {
	              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
	            } else if (sound._node && !sound._muted) {
	              sound._node.volume = vol * Howler.volume();
	            }
	
	            self._emit('volume', sound._id);
	          }
	        }
	      } else {
	        sound = id ? self._soundById(id) : self._sounds[0];
	        return sound ? sound._volume : 0;
	      }
	
	      return self;
	    },
	
	    /**
	     * Fade a currently playing sound between two volumes (if no id is passsed, all sounds will fade).
	     * @param  {Number} from The value to fade from (0.0 to 1.0).
	     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
	     * @param  {Number} len  Time in milliseconds to fade.
	     * @param  {Number} id   The sound id (omit to fade all sounds).
	     * @return {Howl}
	     */
	    fade: function(from, to, len, id) {
	      var self = this;
	      var diff = Math.abs(from - to);
	      var dir = from > to ? 'out' : 'in';
	      var steps = diff / 0.01;
	      var stepLen = (steps > 0) ? len / steps : len;
	
	      // Since browsers clamp timeouts to 4ms, we need to clamp our steps to that too.
	      if (stepLen < 4) {
	        steps = Math.ceil(steps / (4 / stepLen));
	        stepLen = 4;
	      }
	
	      // If the sound hasn't loaded, add it to the load queue to fade when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'fade',
	          action: function() {
	            self.fade(from, to, len, id);
	          }
	        });
	
	        return self;
	      }
	
	      // Set the volume to the start position.
	      self.volume(from, id);
	
	      // Fade the volume of one or all sounds.
	      var ids = self._getSoundIds(id);
	      for (var i=0; i<ids.length; i++) {
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        // Create a linear fade or fall back to timeouts with HTML5 Audio.
	        if (sound) {
	          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
	          if (!id) {
	            self._stopFade(ids[i]);
	          }
	
	          // If we are using Web Audio, let the native methods do the actual fade.
	          if (self._webAudio && !sound._muted) {
	            var currentTime = Howler.ctx.currentTime;
	            var end = currentTime + (len / 1000);
	            sound._volume = from;
	            sound._node.gain.setValueAtTime(from, currentTime);
	            sound._node.gain.linearRampToValueAtTime(to, end);
	          }
	
	          var vol = from;
	          sound._interval = setInterval(function(soundId, sound) {
	            // Update the volume amount, but only if the volume should change.
	            if (steps > 0) {
	              vol += (dir === 'in' ? 0.01 : -0.01);
	            }
	
	            // Make sure the volume is in the right bounds.
	            vol = Math.max(0, vol);
	            vol = Math.min(1, vol);
	
	            // Round to within 2 decimal points.
	            vol = Math.round(vol * 100) / 100;
	
	            // Change the volume.
	            if (self._webAudio) {
	              if (typeof id === 'undefined') {
	                self._volume = vol;
	              }
	
	              sound._volume = vol;
	            } else {
	              self.volume(vol, soundId, true);
	            }
	
	            // When the fade is complete, stop it and fire event.
	            if ((to < from && vol <= to) || (to > from && vol >= to)) {
	              clearInterval(sound._interval);
	              sound._interval = null;
	              self.volume(to, soundId);
	              self._emit('fade', soundId);
	            }
	          }.bind(self, ids[i], sound), stepLen);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Internal method that stops the currently playing fade when
	     * a new fade starts, volume is changed or the sound is stopped.
	     * @param  {Number} id The sound id.
	     * @return {Howl}
	     */
	    _stopFade: function(id) {
	      var self = this;
	      var sound = self._soundById(id);
	
	      if (sound && sound._interval) {
	        if (self._webAudio) {
	          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
	        }
	
	        clearInterval(sound._interval);
	        sound._interval = null;
	        self._emit('fade', id);
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   loop() -> Returns the group's loop value.
	     *   loop(id) -> Returns the sound id's loop value.
	     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
	     *   loop(loop, id) -> Sets the loop value of passed sound id.
	     * @return {Howl/Boolean} Returns self or current loop value.
	     */
	    loop: function() {
	      var self = this;
	      var args = arguments;
	      var loop, id, sound;
	
	      // Determine the values for loop and id.
	      if (args.length === 0) {
	        // Return the grou's loop value.
	        return self._loop;
	      } else if (args.length === 1) {
	        if (typeof args[0] === 'boolean') {
	          loop = args[0];
	          self._loop = loop;
	        } else {
	          // Return this sound's loop value.
	          sound = self._soundById(parseInt(args[0], 10));
	          return sound ? sound._loop : false;
	        }
	      } else if (args.length === 2) {
	        loop = args[0];
	        id = parseInt(args[1], 10);
	      }
	
	      // If no id is passed, get all ID's to be looped.
	      var ids = self._getSoundIds(id);
	      for (var i=0; i<ids.length; i++) {
	        sound = self._soundById(ids[i]);
	
	        if (sound) {
	          sound._loop = loop;
	          if (self._webAudio && sound._node && sound._node.bufferSource) {
	            sound._node.bufferSource.loop = loop;
	            if (loop) {
	              sound._node.bufferSource.loopStart = sound._start || 0;
	              sound._node.bufferSource.loopEnd = sound._stop;
	            }
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   rate() -> Returns the first sound node's current playback rate.
	     *   rate(id) -> Returns the sound id's current playback rate.
	     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
	     *   rate(rate, id) -> Sets the playback rate of passed sound id.
	     * @return {Howl/Number} Returns self or the current playback rate.
	     */
	    rate: function() {
	      var self = this;
	      var args = arguments;
	      var rate, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // We will simply return the current rate of the first node.
	        id = self._sounds[0]._id;
	      } else if (args.length === 1) {
	        // First check if this is an ID, and if not, assume it is a new rate value.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else {
	          rate = parseFloat(args[0]);
	        }
	      } else if (args.length === 2) {
	        rate = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // Update the playback rate or return the current value.
	      var sound;
	      if (typeof rate === 'number') {
	        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
	        if (self._state !== 'loaded') {
	          self._queue.push({
	            event: 'rate',
	            action: function() {
	              self.rate.apply(self, args);
	            }
	          });
	
	          return self;
	        }
	
	        // Set the group rate.
	        if (typeof id === 'undefined') {
	          self._rate = rate;
	        }
	
	        // Update one or all volumes.
	        id = self._getSoundIds(id);
	        for (var i=0; i<id.length; i++) {
	          // Get the sound.
	          sound = self._soundById(id[i]);
	
	          if (sound) {
	            // Keep track of our position when the rate changed and update the playback
	            // start position so we can properly adjust the seek position for time elapsed.
	            sound._rateSeek = self.seek(id[i]);
	            sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
	            sound._rate = rate;
	
	            // Change the playback rate.
	            if (self._webAudio && sound._node && sound._node.bufferSource) {
	              sound._node.bufferSource.playbackRate.value = rate;
	            } else if (sound._node) {
	              sound._node.playbackRate = rate;
	            }
	
	            // Reset the timers.
	            var seek = self.seek(id[i]);
	            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
	            var timeout = (duration * 1000) / Math.abs(sound._rate);
	
	            // Start a new end timer if sound is already playing.
	            if (self._endTimers[id[i]] || !sound._paused) {
	              self._clearTimer(id[i]);
	              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
	            }
	
	            self._emit('rate', sound._id);
	          }
	        }
	      } else {
	        sound = self._soundById(id);
	        return sound ? sound._rate : self._rate;
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   seek() -> Returns the first sound node's current seek position.
	     *   seek(id) -> Returns the sound id's current seek position.
	     *   seek(seek) -> Sets the seek position of the first sound node.
	     *   seek(seek, id) -> Sets the seek position of passed sound id.
	     * @return {Howl/Number} Returns self or the current seek position.
	     */
	    seek: function() {
	      var self = this;
	      var args = arguments;
	      var seek, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // We will simply return the current position of the first node.
	        id = self._sounds[0]._id;
	      } else if (args.length === 1) {
	        // First check if this is an ID, and if not, assume it is a new seek position.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else {
	          id = self._sounds[0]._id;
	          seek = parseFloat(args[0]);
	        }
	      } else if (args.length === 2) {
	        seek = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // If there is no ID, bail out.
	      if (typeof id === 'undefined') {
	        return self;
	      }
	
	      // If the sound hasn't loaded, add it to the load queue to seek when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'seek',
	          action: function() {
	            self.seek.apply(self, args);
	          }
	        });
	
	        return self;
	      }
	
	      // Get the sound.
	      var sound = self._soundById(id);
	
	      if (sound) {
	        if (typeof seek === 'number' && seek >= 0) {
	          // Pause the sound and update position for restarting playback.
	          var playing = self.playing(id);
	          if (playing) {
	            self.pause(id, true);
	          }
	
	          // Move the position of the track and cancel timer.
	          sound._seek = seek;
	          sound._ended = false;
	          self._clearTimer(id);
	
	          // Restart the playback if the sound was playing.
	          if (playing) {
	            self.play(id, true);
	          }
	
	          // Update the seek position for HTML5 Audio.
	          if (!self._webAudio && sound._node) {
	            sound._node.currentTime = seek;
	          }
	
	          self._emit('seek', id);
	        } else {
	          if (self._webAudio) {
	            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
	            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
	            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
	          } else {
	            return sound._node.currentTime;
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
	     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
	     * @return {Boolean} True if playing and false if not.
	     */
	    playing: function(id) {
	      var self = this;
	
	      // Check the passed sound ID (if any).
	      if (typeof id === 'number') {
	        var sound = self._soundById(id);
	        return sound ? !sound._paused : false;
	      }
	
	      // Otherwise, loop through all sounds and check if any are playing.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (!self._sounds[i]._paused) {
	          return true;
	        }
	      }
	
	      return false;
	    },
	
	    /**
	     * Get the duration of this sound. Passing a sound id will return the sprite duration.
	     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
	     * @return {Number} Audio duration in seconds.
	     */
	    duration: function(id) {
	      var self = this;
	      var duration = self._duration;
	
	      // If we pass an ID, get the sound and return the sprite length.
	      var sound = self._soundById(id);
	      if (sound) {
	        duration = self._sprite[sound._sprite][1] / 1000;
	      }
	
	      return duration;
	    },
	
	    /**
	     * Returns the current loaded state of this Howl.
	     * @return {String} 'unloaded', 'loading', 'loaded'
	     */
	    state: function() {
	      return this._state;
	    },
	
	    /**
	     * Unload and destroy the current Howl object.
	     * This will immediately stop all sound instances attached to this group.
	     */
	    unload: function() {
	      var self = this;
	
	      // Stop playing any active sounds.
	      var sounds = self._sounds;
	      for (var i=0; i<sounds.length; i++) {
	        // Stop the sound if it is currently playing.
	        if (!sounds[i]._paused) {
	          self.stop(sounds[i]._id);
	        }
	
	        // Remove the source or disconnect.
	        if (!self._webAudio) {
	          // Set the source to 0-second silence to stop any downloading.
	          sounds[i]._node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
	
	          // Remove any event listeners.
	          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
	          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
	        }
	
	        // Empty out all of the nodes.
	        delete sounds[i]._node;
	
	        // Make sure all timers are cleared out.
	        self._clearTimer(sounds[i]._id);
	
	        // Remove the references in the global Howler object.
	        var index = Howler._howls.indexOf(self);
	        if (index >= 0) {
	          Howler._howls.splice(index, 1);
	        }
	      }
	
	      // Delete this sound from the cache (if no other Howl is using it).
	      var remCache = true;
	      for (i=0; i<Howler._howls.length; i++) {
	        if (Howler._howls[i]._src === self._src) {
	          remCache = false;
	          break;
	        }
	      }
	
	      if (cache && remCache) {
	        delete cache[self._src];
	      }
	
	      // Clear global errors.
	      Howler.noAudio = false;
	
	      // Clear out `self`.
	      self._state = 'unloaded';
	      self._sounds = [];
	      self = null;
	
	      return null;
	    },
	
	    /**
	     * Listen to a custom event.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to call.
	     * @param  {Number}   id    (optional) Only listen to events for this sound.
	     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
	     * @return {Howl}
	     */
	    on: function(event, fn, id, once) {
	      var self = this;
	      var events = self['_on' + event];
	
	      if (typeof fn === 'function') {
	        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
	      }
	
	      return self;
	    },
	
	    /**
	     * Remove a custom event. Call without parameters to remove all events.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
	     * @param  {Number}   id    (optional) Only remove events for this sound.
	     * @return {Howl}
	     */
	    off: function(event, fn, id) {
	      var self = this;
	      var events = self['_on' + event];
	      var i = 0;
	
	      if (fn) {
	        // Loop through event store and remove the passed function.
	        for (i=0; i<events.length; i++) {
	          if (fn === events[i].fn && id === events[i].id) {
	            events.splice(i, 1);
	            break;
	          }
	        }
	      } else if (event) {
	        // Clear out all events of this type.
	        self['_on' + event] = [];
	      } else {
	        // Clear out all events of every type.
	        var keys = Object.keys(self);
	        for (i=0; i<keys.length; i++) {
	          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
	            self[keys[i]] = [];
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Listen to a custom event and remove it once fired.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to call.
	     * @param  {Number}   id    (optional) Only listen to events for this sound.
	     * @return {Howl}
	     */
	    once: function(event, fn, id) {
	      var self = this;
	
	      // Setup the event listener.
	      self.on(event, fn, id, 1);
	
	      return self;
	    },
	
	    /**
	     * Emit all events of a specific type and pass the sound id.
	     * @param  {String} event Event name.
	     * @param  {Number} id    Sound ID.
	     * @param  {Number} msg   Message to go with event.
	     * @return {Howl}
	     */
	    _emit: function(event, id, msg) {
	      var self = this;
	      var events = self['_on' + event];
	
	      // Loop through event store and fire all functions.
	      for (var i=events.length-1; i>=0; i--) {
	        if (!events[i].id || events[i].id === id || event === 'load') {
	          setTimeout(function(fn) {
	            fn.call(this, id, msg);
	          }.bind(self, events[i].fn), 0);
	
	          // If this event was setup with `once`, remove it.
	          if (events[i].once) {
	            self.off(event, events[i].fn, events[i].id);
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Queue of actions initiated before the sound has loaded.
	     * These will be called in sequence, with the next only firing
	     * after the previous has finished executing (even if async like play).
	     * @return {Howl}
	     */
	    _loadQueue: function() {
	      var self = this;
	
	      if (self._queue.length > 0) {
	        var task = self._queue[0];
	
	        // don't move onto the next task until this one is done
	        self.once(task.event, function() {
	          self._queue.shift();
	          self._loadQueue();
	        });
	
	        task.action();
	      }
	
	      return self;
	    },
	
	    /**
	     * Fired when playback ends at the end of the duration.
	     * @param  {Sound} sound The sound object to work with.
	     * @return {Howl}
	     */
	    _ended: function(sound) {
	      var self = this;
	      var sprite = sound._sprite;
	
	      // Should this sound loop?
	      var loop = !!(sound._loop || self._sprite[sprite][2]);
	
	      // Fire the ended event.
	      self._emit('end', sound._id);
	
	      // Restart the playback for HTML5 Audio loop.
	      if (!self._webAudio && loop) {
	        self.stop(sound._id, true).play(sound._id);
	      }
	
	      // Restart this timer if on a Web Audio loop.
	      if (self._webAudio && loop) {
	        self._emit('play', sound._id);
	        sound._seek = sound._start || 0;
	        sound._rateSeek = 0;
	        sound._playStart = Howler.ctx.currentTime;
	
	        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
	        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	      }
	
	      // Mark the node as paused.
	      if (self._webAudio && !loop) {
	        sound._paused = true;
	        sound._ended = true;
	        sound._seek = sound._start || 0;
	        sound._rateSeek = 0;
	        self._clearTimer(sound._id);
	
	        // Clean up the buffer source.
	        self._cleanBuffer(sound._node);
	
	        // Attempt to auto-suspend AudioContext if no sounds are still playing.
	        Howler._autoSuspend();
	      }
	
	      // When using a sprite, end the track.
	      if (!self._webAudio && !loop) {
	        self.stop(sound._id);
	      }
	
	      return self;
	    },
	
	    /**
	     * Clear the end timer for a sound playback.
	     * @param  {Number} id The sound ID.
	     * @return {Howl}
	     */
	    _clearTimer: function(id) {
	      var self = this;
	
	      if (self._endTimers[id]) {
	        clearTimeout(self._endTimers[id]);
	        delete self._endTimers[id];
	      }
	
	      return self;
	    },
	
	    /**
	     * Return the sound identified by this ID, or return null.
	     * @param  {Number} id Sound ID
	     * @return {Object}    Sound object or null.
	     */
	    _soundById: function(id) {
	      var self = this;
	
	      // Loop through all sounds and find the one with this ID.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (id === self._sounds[i]._id) {
	          return self._sounds[i];
	        }
	      }
	
	      return null;
	    },
	
	    /**
	     * Return an inactive sound from the pool or create a new one.
	     * @return {Sound} Sound playback object.
	     */
	    _inactiveSound: function() {
	      var self = this;
	
	      self._drain();
	
	      // Find the first inactive node to recycle.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (self._sounds[i]._ended) {
	          return self._sounds[i].reset();
	        }
	      }
	
	      // If no inactive node was found, create a new one.
	      return new Sound(self);
	    },
	
	    /**
	     * Drain excess inactive sounds from the pool.
	     */
	    _drain: function() {
	      var self = this;
	      var limit = self._pool;
	      var cnt = 0;
	      var i = 0;
	
	      // If there are less sounds than the max pool size, we are done.
	      if (self._sounds.length < limit) {
	        return;
	      }
	
	      // Count the number of inactive sounds.
	      for (i=0; i<self._sounds.length; i++) {
	        if (self._sounds[i]._ended) {
	          cnt++;
	        }
	      }
	
	      // Remove excess inactive sounds, going in reverse order.
	      for (i=self._sounds.length - 1; i>=0; i--) {
	        if (cnt <= limit) {
	          return;
	        }
	
	        if (self._sounds[i]._ended) {
	          // Disconnect the audio source when using Web Audio.
	          if (self._webAudio && self._sounds[i]._node) {
	            self._sounds[i]._node.disconnect(0);
	          }
	
	          // Remove sounds until we have the pool size.
	          self._sounds.splice(i, 1);
	          cnt--;
	        }
	      }
	    },
	
	    /**
	     * Get all ID's from the sounds pool.
	     * @param  {Number} id Only return one ID if one is passed.
	     * @return {Array}    Array of IDs.
	     */
	    _getSoundIds: function(id) {
	      var self = this;
	
	      if (typeof id === 'undefined') {
	        var ids = [];
	        for (var i=0; i<self._sounds.length; i++) {
	          ids.push(self._sounds[i]._id);
	        }
	
	        return ids;
	      } else {
	        return [id];
	      }
	    },
	
	    /**
	     * Load the sound back into the buffer source.
	     * @param  {Sound} sound The sound object to work with.
	     * @return {Howl}
	     */
	    _refreshBuffer: function(sound) {
	      var self = this;
	
	      // Setup the buffer source for playback.
	      sound._node.bufferSource = Howler.ctx.createBufferSource();
	      sound._node.bufferSource.buffer = cache[self._src];
	
	      // Connect to the correct node.
	      if (sound._panner) {
	        sound._node.bufferSource.connect(sound._panner);
	      } else {
	        sound._node.bufferSource.connect(sound._node);
	      }
	
	      // Setup looping and playback rate.
	      sound._node.bufferSource.loop = sound._loop;
	      if (sound._loop) {
	        sound._node.bufferSource.loopStart = sound._start || 0;
	        sound._node.bufferSource.loopEnd = sound._stop;
	      }
	      sound._node.bufferSource.playbackRate.value = sound._rate;
	
	      return self;
	    },
	
	    /**
	     * Prevent memory leaks by cleaning up the buffer source after playback.
	     * @param  {Object} node Sound's audio node containing the buffer source.
	     * @return {Howl}
	     */
	    _cleanBuffer: function(node) {
	      var self = this;
	
	      if (self._scratchBuffer) {
	        node.bufferSource.onended = null;
	        node.bufferSource.disconnect(0);
	        try { node.bufferSource.buffer = self._scratchBuffer; } catch(e) {}
	      }
	      node.bufferSource = null;
	
	      return self;
	    }
	  };
	
	  /** Single Sound Methods **/
	  /***************************************************************************/
	
	  /**
	   * Setup the sound object, which each node attached to a Howl group is contained in.
	   * @param {Object} howl The Howl parent group.
	   */
	  var Sound = function(howl) {
	    this._parent = howl;
	    this.init();
	  };
	  Sound.prototype = {
	    /**
	     * Initialize a new Sound object.
	     * @return {Sound}
	     */
	    init: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Setup the default parameters.
	      self._muted = parent._muted;
	      self._loop = parent._loop;
	      self._volume = parent._volume;
	      self._muted = parent._muted;
	      self._rate = parent._rate;
	      self._seek = 0;
	      self._paused = true;
	      self._ended = true;
	      self._sprite = '__default';
	
	      // Generate a unique ID for this sound.
	      self._id = ++Howler._counter;
	
	      // Add itself to the parent's pool.
	      parent._sounds.push(self);
	
	      // Create the new node.
	      self.create();
	
	      return self;
	    },
	
	    /**
	     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
	     * @return {Sound}
	     */
	    create: function() {
	      var self = this;
	      var parent = self._parent;
	      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;
	
	      if (parent._webAudio) {
	        // Create the gain node for controlling volume (the source will connect to this).
	        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
	        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
	        self._node.paused = true;
	        self._node.connect(Howler.masterGain);
	      } else {
	        self._node = new Audio();
	
	        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
	        self._errorFn = self._errorListener.bind(self);
	        self._node.addEventListener('error', self._errorFn, false);
	
	        // Listen for 'canplaythrough' event to let us know the sound is ready.
	        self._loadFn = self._loadListener.bind(self);
	        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);
	
	        // Setup the new audio node.
	        self._node.src = parent._src;
	        self._node.preload = 'auto';
	        self._node.volume = volume * Howler.volume();
	
	        // Begin loading the source.
	        self._node.load();
	      }
	
	      return self;
	    },
	
	    /**
	     * Reset the parameters of this sound to the original state (for recycle).
	     * @return {Sound}
	     */
	    reset: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Reset all of the parameters of this sound.
	      self._muted = parent._muted;
	      self._loop = parent._loop;
	      self._volume = parent._volume;
	      self._muted = parent._muted;
	      self._rate = parent._rate;
	      self._seek = 0;
	      self._rateSeek = 0;
	      self._paused = true;
	      self._ended = true;
	      self._sprite = '__default';
	
	      // Generate a new ID so that it isn't confused with the previous sound.
	      self._id = ++Howler._counter;
	
	      return self;
	    },
	
	    /**
	     * HTML5 Audio error listener callback.
	     */
	    _errorListener: function() {
	      var self = this;
	
	      // Fire an error event and pass back the code.
	      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);
	
	      // Clear the event listener.
	      self._node.removeEventListener('error', self._errorListener, false);
	    },
	
	    /**
	     * HTML5 Audio canplaythrough listener callback.
	     */
	    _loadListener: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Round up the duration to account for the lower precision in HTML5 Audio.
	      parent._duration = Math.ceil(self._node.duration * 10) / 10;
	
	      // Setup a sprite if none is defined.
	      if (Object.keys(parent._sprite).length === 0) {
	        parent._sprite = {__default: [0, parent._duration * 1000]};
	      }
	
	      if (parent._state !== 'loaded') {
	        parent._state = 'loaded';
	        parent._emit('load');
	        parent._loadQueue();
	      }
	
	      // Clear the event listener.
	      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
	    }
	  };
	
	  /** Helper Methods **/
	  /***************************************************************************/
	
	  var cache = {};
	
	  /**
	   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
	   * @param  {Howl} self
	   */
	  var loadBuffer = function(self) {
	    var url = self._src;
	
	    // Check if the buffer has already been cached and use it instead.
	    if (cache[url]) {
	      // Set the duration from the cache.
	      self._duration = cache[url].duration;
	
	      // Load the sound into this Howl.
	      loadSound(self);
	
	      return;
	    }
	
	    if (/^data:[^;]+;base64,/.test(url)) {
	      // Decode the base64 data URI without XHR, since some browsers don't support it.
	      var data = atob(url.split(',')[1]);
	      var dataView = new Uint8Array(data.length);
	      for (var i=0; i<data.length; ++i) {
	        dataView[i] = data.charCodeAt(i);
	      }
	
	      decodeAudioData(dataView.buffer, self);
	    } else {
	      // Load the buffer from the URL.
	      var xhr = new XMLHttpRequest();
	      xhr.open('GET', url, true);
	      xhr.responseType = 'arraybuffer';
	      xhr.onload = function() {
	        // Make sure we get a successful response back.
	        var code = (xhr.status + '')[0];
	        if (code !== '0' && code !== '2' && code !== '3') {
	          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
	          return;
	        }
	
	        decodeAudioData(xhr.response, self);
	      };
	      xhr.onerror = function() {
	        // If there is an error, switch to HTML5 Audio.
	        if (self._webAudio) {
	          self._html5 = true;
	          self._webAudio = false;
	          self._sounds = [];
	          delete cache[url];
	          self.load();
	        }
	      };
	      safeXhrSend(xhr);
	    }
	  };
	
	  /**
	   * Send the XHR request wrapped in a try/catch.
	   * @param  {Object} xhr XHR to send.
	   */
	  var safeXhrSend = function(xhr) {
	    try {
	      xhr.send();
	    } catch (e) {
	      xhr.onerror();
	    }
	  };
	
	  /**
	   * Decode audio data from an array buffer.
	   * @param  {ArrayBuffer} arraybuffer The audio data.
	   * @param  {Howl}        self
	   */
	  var decodeAudioData = function(arraybuffer, self) {
	    // Decode the buffer into an audio source.
	    Howler.ctx.decodeAudioData(arraybuffer, function(buffer) {
	      if (buffer && self._sounds.length > 0) {
	        cache[self._src] = buffer;
	        loadSound(self, buffer);
	      }
	    }, function() {
	      self._emit('loaderror', null, 'Decoding audio data failed.');
	    });
	  };
	
	  /**
	   * Sound is now loaded, so finish setting everything up and fire the loaded event.
	   * @param  {Howl} self
	   * @param  {Object} buffer The decoded buffer sound source.
	   */
	  var loadSound = function(self, buffer) {
	    // Set the duration.
	    if (buffer && !self._duration) {
	      self._duration = buffer.duration;
	    }
	
	    // Setup a sprite if none is defined.
	    if (Object.keys(self._sprite).length === 0) {
	      self._sprite = {__default: [0, self._duration * 1000]};
	    }
	
	    // Fire the loaded event.
	    if (self._state !== 'loaded') {
	      self._state = 'loaded';
	      self._emit('load');
	      self._loadQueue();
	    }
	  };
	
	  /**
	   * Setup the audio context when available, or switch to HTML5 Audio mode.
	   */
	  var setupAudioContext = function() {
	    // Check if we are using Web Audio and setup the AudioContext if we are.
	    try {
	      if (typeof AudioContext !== 'undefined') {
	        Howler.ctx = new AudioContext();
	      } else if (typeof webkitAudioContext !== 'undefined') {
	        Howler.ctx = new webkitAudioContext();
	      } else {
	        Howler.usingWebAudio = false;
	      }
	    } catch(e) {
	      Howler.usingWebAudio = false;
	    }
	
	    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
	    // If it is, disable Web Audio as it causes crashing.
	    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
	    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	    var version = appVersion ? parseInt(appVersion[1], 10) : null;
	    if (iOS && version && version < 9) {
	      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
	      if (Howler._navigator && Howler._navigator.standalone && !safari || Howler._navigator && !Howler._navigator.standalone && !safari) {
	        Howler.usingWebAudio = false;
	      }
	    }
	
	    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
	    if (Howler.usingWebAudio) {
	      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
	      Howler.masterGain.gain.value = 1;
	      Howler.masterGain.connect(Howler.ctx.destination);
	    }
	
	    // Re-run the setup on Howler.
	    Howler._setup();
	  };
	
	  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return {
	        Howler: Howler,
	        Howl: Howl
	      };
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  // Add support for CommonJS libraries such as browserify.
	  if (true) {
	    exports.Howler = Howler;
	    exports.Howl = Howl;
	  }
	
	  // Define globally in case AMD is not available or unused.
	  if (typeof window !== 'undefined') {
	    window.HowlerGlobal = HowlerGlobal;
	    window.Howler = Howler;
	    window.Howl = Howl;
	    window.Sound = Sound;
	  } else if (typeof global !== 'undefined') { // Add to global in Node.js (for testing, etc).
	    global.HowlerGlobal = HowlerGlobal;
	    global.Howler = Howler;
	    global.Howl = Howl;
	    global.Sound = Sound;
	  }
	})();
	
	
	/*!
	 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
	 *  
	 *  howler.js v2.0.3
	 *  howlerjs.com
	 *
	 *  (c) 2013-2017, James Simpson of GoldFire Studios
	 *  goldfirestudios.com
	 *
	 *  MIT License
	 */
	
	(function() {
	
	  'use strict';
	
	  // Setup default properties.
	  HowlerGlobal.prototype._pos = [0, 0, 0];
	  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];
	  
	  /** Global Methods **/
	  /***************************************************************************/
	
	  /**
	   * Helper method to update the stereo panning position of all current Howls.
	   * Future Howls will not use this value unless explicitly set.
	   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
	   * @return {Howler/Number}     Self or current stereo panning value.
	   */
	  HowlerGlobal.prototype.stereo = function(pan) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Loop through all Howls and update their stereo panning.
	    for (var i=self._howls.length-1; i>=0; i--) {
	      self._howls[i].stereo(pan);
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the position of the listener in 3D cartesian space. Sounds using
	   * 3D position will be relative to the listener's position.
	   * @param  {Number} x The x-position of the listener.
	   * @param  {Number} y The y-position of the listener.
	   * @param  {Number} z The z-position of the listener.
	   * @return {Howler/Array}   Self or current listener position.
	   */
	  HowlerGlobal.prototype.pos = function(x, y, z) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? self._pos[1] : y;
	    z = (typeof z !== 'number') ? self._pos[2] : z;
	
	    if (typeof x === 'number') {
	      self._pos = [x, y, z];
	      self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
	    } else {
	      return self._pos;
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the direction the listener is pointing in the 3D cartesian space.
	   * A front and up vector must be provided. The front is the direction the
	   * face of the listener is pointing, and up is the direction the top of the
	   * listener is pointing. Thus, these values are expected to be at right angles
	   * from each other.
	   * @param  {Number} x   The x-orientation of the listener.
	   * @param  {Number} y   The y-orientation of the listener.
	   * @param  {Number} z   The z-orientation of the listener.
	   * @param  {Number} xUp The x-orientation of the top of the listener.
	   * @param  {Number} yUp The y-orientation of the top of the listener.
	   * @param  {Number} zUp The z-orientation of the top of the listener.
	   * @return {Howler/Array}     Returns self or the current orientation vectors.
	   */
	  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    var or = self._orientation;
	    y = (typeof y !== 'number') ? or[1] : y;
	    z = (typeof z !== 'number') ? or[2] : z;
	    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
	    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
	    zUp = (typeof zUp !== 'number') ? or[5] : zUp;
	
	    if (typeof x === 'number') {
	      self._orientation = [x, y, z, xUp, yUp, zUp];
	      self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
	    } else {
	      return or;
	    }
	
	    return self;
	  };
	
	  /** Group Methods **/
	  /***************************************************************************/
	
	  /**
	   * Add new properties to the core init.
	   * @param  {Function} _super Core init method.
	   * @return {Howl}
	   */
	  Howl.prototype.init = (function(_super) {
	    return function(o) {
	      var self = this;
	
	      // Setup user-defined default properties.
	      self._orientation = o.orientation || [1, 0, 0];
	      self._stereo = o.stereo || null;
	      self._pos = o.pos || null;
	      self._pannerAttr = {
	        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
	        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
	        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
	        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
	        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
	        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
	        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
	        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
	      };
	
	      // Setup event listeners.
	      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
	      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
	      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];
	
	      // Complete initilization with howler.js core's init function.
	      return _super.call(this, o);
	    };
	  })(Howl.prototype.init);
	
	  /**
	   * Get/set the stereo panning of the audio source for this sound or all in the group.
	   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Number}    Returns self or the current stereo panning value.
	   */
	  Howl.prototype.stereo = function(pan, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'stereo',
	        action: function() {
	          self.stereo(pan, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
	    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';
	
	    // Setup the group's stereo panning if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's stereo panning if no parameters are passed.
	      if (typeof pan === 'number') {
	        self._stereo = pan;
	        self._pos = [pan, 0, 0];
	      } else {
	        return self._stereo;
	      }
	    }
	
	    // Change the streo panning of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof pan === 'number') {
	          sound._stereo = pan;
	          sound._pos = [pan, 0, 0];
	
	          if (sound._node) {
	            // If we are falling back, make sure the panningModel is equalpower.
	            sound._pannerAttr.panningModel = 'equalpower';
	
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner || !sound._panner.pan) {
	              setupPanner(sound, pannerType);
	            }
	
	            if (pannerType === 'spatial') {
	              sound._panner.setPosition(pan, 0, 0);
	            } else {
	              sound._panner.pan.value = pan;
	            }
	          }
	
	          self._emit('stereo', sound._id);
	        } else {
	          return sound._stereo;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the 3D spatial position of the audio source for this sound or
	   * all in the group. The most common usage is to set the 'x' position for
	   * left/right panning. Setting any value higher than 1.0 will begin to
	   * decrease the volume of the sound as it moves further away.
	   * @param  {Number} x  The x-position of the audio from -1000.0 to 1000.0.
	   * @param  {Number} y  The y-position of the audio from -1000.0 to 1000.0.
	   * @param  {Number} z  The z-position of the audio from -1000.0 to 1000.0.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
	   */
	  Howl.prototype.pos = function(x, y, z, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change position when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'pos',
	        action: function() {
	          self.pos(x, y, z, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? 0 : y;
	    z = (typeof z !== 'number') ? -0.5 : z;
	
	    // Setup the group's spatial position if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's spatial position if no parameters are passed.
	      if (typeof x === 'number') {
	        self._pos = [x, y, z];
	      } else {
	        return self._pos;
	      }
	    }
	
	    // Change the spatial position of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof x === 'number') {
	          sound._pos = [x, y, z];
	
	          if (sound._node) {
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner || sound._panner.pan) {
	              setupPanner(sound, 'spatial');
	            }
	
	            sound._panner.setPosition(x, y, z);
	          }
	
	          self._emit('pos', sound._id);
	        } else {
	          return sound._pos;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
	   * space. Depending on how direction the sound is, based on the `cone` attributes,
	   * a sound pointing away from the listener can be quiet or silent.
	   * @param  {Number} x  The x-orientation of the source.
	   * @param  {Number} y  The y-orientation of the source.
	   * @param  {Number} z  The z-orientation of the source.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
	   */
	  Howl.prototype.orientation = function(x, y, z, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'orientation',
	        action: function() {
	          self.orientation(x, y, z, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? self._orientation[1] : y;
	    z = (typeof z !== 'number') ? self._orientation[2] : z;
	
	    // Setup the group's spatial orientation if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's spatial orientation if no parameters are passed.
	      if (typeof x === 'number') {
	        self._orientation = [x, y, z];
	      } else {
	        return self._orientation;
	      }
	    }
	
	    // Change the spatial orientation of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof x === 'number') {
	          sound._orientation = [x, y, z];
	
	          if (sound._node) {
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner) {
	              // Make sure we have a position to setup the node with.
	              if (!sound._pos) {
	                sound._pos = self._pos || [0, 0, -0.5];
	              }
	
	              setupPanner(sound, 'spatial');
	            }
	
	            sound._panner.setOrientation(x, y, z);
	          }
	
	          self._emit('orientation', sound._id);
	        } else {
	          return sound._orientation;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the panner node's attributes for a sound or group of sounds.
	   * This method can optionall take 0, 1 or 2 arguments.
	   *   pannerAttr() -> Returns the group's values.
	   *   pannerAttr(id) -> Returns the sound id's values.
	   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
	   *   pannerAttr(o, id) -> Set's the values of passed sound id.
	   *
	   *   Attributes:
	   *     coneInnerAngle - (360 by default) There will be no volume reduction inside this angle.
	   *     coneOuterAngle - (360 by default) The volume will be reduced to a constant value of
	   *                      `coneOuterGain` outside this angle.
	   *     coneOuterGain - (0 by default) The amount of volume reduction outside of `coneOuterAngle`.
	   *     distanceModel - ('inverse' by default) Determines algorithm to use to reduce volume as audio moves
	   *                      away from listener. Can be `linear`, `inverse` or `exponential`.
	   *     maxDistance - (10000 by default) Volume won't reduce between source/listener beyond this distance.
	   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
	   *                     Can be `HRTF` or `equalpower`.
	   *     refDistance - (1 by default) A reference distance for reducing volume as the source
	   *                    moves away from the listener.
	   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener.
	   * 
	   * @return {Howl/Object} Returns self or current panner attributes.
	   */
	  Howl.prototype.pannerAttr = function() {
	    var self = this;
	    var args = arguments;
	    var o, id, sound;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // Determine the values based on arguments.
	    if (args.length === 0) {
	      // Return the group's panner attribute values.
	      return self._pannerAttr;
	    } else if (args.length === 1) {
	      if (typeof args[0] === 'object') {
	        o = args[0];
	
	        // Set the grou's panner attribute values.
	        if (typeof id === 'undefined') {
	          self._pannerAttr = {
	            coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : self._coneInnerAngle,
	            coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : self._coneOuterAngle,
	            coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : self._coneOuterGain,
	            distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : self._distanceModel,
	            maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : self._maxDistance,
	            panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : self._panningModel,
	            refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : self._refDistance,
	            rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : self._rolloffFactor
	          };
	        }
	      } else {
	        // Return this sound's panner attribute values.
	        sound = self._soundById(parseInt(args[0], 10));
	        return sound ? sound._pannerAttr : self._pannerAttr;
	      }
	    } else if (args.length === 2) {
	      o = args[0];
	      id = parseInt(args[1], 10);
	    }
	
	    // Update the values of the specified sounds.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      sound = self._soundById(ids[i]);
	
	      if (sound) {
	        // Merge the new values into the sound.
	        var pa = sound._pannerAttr;
	        pa = {
	          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
	          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
	          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
	          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
	          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
	          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel,
	          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
	          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor
	        };
	
	        // Update the panner values or create a new panner if none exists.
	        var panner = sound._panner;
	        if (panner) {
	          panner.coneInnerAngle = pa.coneInnerAngle;
	          panner.coneOuterAngle = pa.coneOuterAngle;
	          panner.coneOuterGain = pa.coneOuterGain;
	          panner.distanceModel = pa.distanceModel;
	          panner.maxDistance = pa.maxDistance;
	          panner.panningModel = pa.panningModel;
	          panner.refDistance = pa.refDistance;
	          panner.rolloffFactor = pa.rolloffFactor;
	        } else {
	          // Make sure we have a position to setup the node with.
	          if (!sound._pos) {
	            sound._pos = self._pos || [0, 0, -0.5];
	          }
	
	          // Create a new panner node.
	          setupPanner(sound, 'spatial');
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /** Single Sound Methods **/
	  /***************************************************************************/
	
	  /**
	   * Add new properties to the core Sound init.
	   * @param  {Function} _super Core Sound init method.
	   * @return {Sound}
	   */
	  Sound.prototype.init = (function(_super) {
	    return function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Setup user-defined default properties.
	      self._orientation = parent._orientation;
	      self._stereo = parent._stereo;
	      self._pos = parent._pos;
	      self._pannerAttr = parent._pannerAttr;
	
	      // Complete initilization with howler.js core Sound's init function.
	      _super.call(this);
	
	      // If a stereo or position was specified, set it up.
	      if (self._stereo) {
	        parent.stereo(self._stereo);
	      } else if (self._pos) {
	        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
	      }
	    };
	  })(Sound.prototype.init);
	
	  /**
	   * Override the Sound.reset method to clean up properties from the spatial plugin.
	   * @param  {Function} _super Sound reset method.
	   * @return {Sound}
	   */
	  Sound.prototype.reset = (function(_super) {
	    return function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Reset all spatial plugin properties on this sound.
	      self._orientation = parent._orientation;
	      self._pos = parent._pos;
	      self._pannerAttr = parent._pannerAttr;
	
	      // Complete resetting of the sound.
	      return _super.call(this);
	    };
	  })(Sound.prototype.reset);
	
	  /** Helper Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create a new panner node and save it on the sound.
	   * @param  {Sound} sound Specific sound to setup panning on.
	   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
	   */
	  var setupPanner = function(sound, type) {
	    type = type || 'spatial';
	
	    // Create the new panner node.
	    if (type === 'spatial') {
	      sound._panner = Howler.ctx.createPanner();
	      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
	      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
	      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
	      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
	      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
	      sound._panner.panningModel = sound._pannerAttr.panningModel;
	      sound._panner.refDistance = sound._pannerAttr.refDistance;
	      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
	      sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
	      sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
	    } else {
	      sound._panner = Howler.ctx.createStereoPanner();
	      sound._panner.pan.value = sound._stereo;
	    }
	
	    sound._panner.connect(sound._node);
	
	    // Update the connections.
	    if (!sound._paused) {
	      sound._parent.pause(sound._id, true).play(sound._id);
	    }
	  };
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(33)
	
	/* template */
	var __vue_template__ = __webpack_require__(114)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(127)
	
	/* script */
	__vue_exports__ = __webpack_require__(43)
	
	/* template */
	var __vue_template__ = __webpack_require__(122)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vuexRouterSync = __webpack_require__(31);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(48);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _Carousel = __webpack_require__(102);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _data = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default); //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'App',
	    components: {
	        Carousel: _Carousel2.default
	    },
	    data: function data() {
	        return {
	            orientation: ''
	        };
	    },
	    mounted: function mounted() {
	        var _this = this;
	
	        window.unlockallthethings = function () {
	            _this.$store.dispatch('ENABLE_DEBUGMODE');
	        };
	        this.$store.dispatch('UNLOCK_EPISODE', { episode: 0 });
	        if (!this.$mobile) {
	            this.animateBG();
	        }
	        this.checkMobile();
	        window.addEventListener('orientationchange', function () {
	            _this.$nextTick(function () {
	                _this.checkOrientation();
	            });
	        });
	        this.$nextTick(function () {
	            _this.checkOrientation();
	        });
	    },
	
	    computed: {
	        thumbnail: {
	            get: function get() {
	                return _data.episodes[this.$store.state.game.episode].thumbnail;
	            }
	        }
	    },
	    methods: {
	        checkOrientation: function checkOrientation() {
	            var _this2 = this;
	
	            this.orientation = '';
	            setTimeout(function () {
	                _this2.orientation = window.innerHeight < window.innerWidth ? 'landscape' : 'portrait';
	            }, 300);
	        },
	        animateBG: function animateBG() {
	            var _this3 = this;
	
	            TweenLite.set('.main-bg-cover', { z: 100, opacity: 0.9 });
	            TweenLite.set('.main-bg-image', { z: -100 });
	            TweenLite.to('.main-bg-image', 60, { delay: 20, scale: 1.05, x: 15, y: -15, ease: "bg-wiggle", onComplete: function onComplete() {
	                    _this3.animateBG();
	                } });
	        },
	        checkMobile: function checkMobile() {
	            // if (/Android|webOS|iPhone|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
	            //     $('.desktop-view').css('display', 'none')
	            //     $('.mobile-view').css('display', 'block')
	            // } else {
	            //     $('.desktop-view').css('display', 'block')
	            //     $('.mobile-view').css('display', 'none')
	            // }
	        }
	    },
	    store: _store2.default,
	    router: _router2.default
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	__webpack_require__(51);
	
	exports.default = {
	    name: 'Answers',
	    props: {
	        type: String,
	        popup: Boolean,
	        mod: 0
	    },
	    data: function data() {
	        return {
	            cards: -1
	        };
	    },
	    mounted: function mounted() {
	        this.cards = -1;
	        var answerCards = document.querySelectorAll('.answer-card');
	        for (var card in answerCards) {
	            if (_typeof(answerCards[card]) === 'object') {
	                this.beforeEnter(answerCards[card]);
	                this.enter(answerCards[card]);
	            }
	        }
	    },
	
	    methods: {
	        width: function width() {
	            return this.type === 'inline' ? 100 / (this.cards + 1) + '%' : '230px';
	        },
	        beforeEnter: function beforeEnter(el) {
	            TweenMax.set(el, { scale: 1.5, opacity: 0, force3D: true });
	        },
	        enter: function enter(el, done) {
	            this.cards++;
	
	            var max = 5;
	            var min = -5;
	            var degrees = Math.floor(Math.random() * (max - min + 1)) + min;
	            var y = this.type === 'compact' ? this.cards * (window.innerHeight * 0.075) : 0;
	
	            TweenMax.to(el, 0.3, { scale: 1, opacity: 1, rotation: degrees, y: y, onComplete: done, force3D: true }, 0.2);
	        },
	        leave: function leave(el, done) {
	            TweenMax.to(el, 0.3, { scale: 0.6, opacity: 0, onComplete: done, force3D: true }, 0.2);
	        },
	        expand: function expand(index) {
	            this.$store.dispatch('SHOW_CAROUSEL', { active: index });
	        }
	    },
	    computed: {
	        answers: {
	            get: function get() {
	                return this.$store.state.game.episodes[this.$store.state.game.episode - this.mod].answers;
	            }
	        }
	    }
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(52);
	
	exports.default = {
	    name: 'answers-slideshow',
	    data: function data() {
	        return {
	            current: 0,
	            direction: null
	        };
	    },
	    props: {
	        mod: {
	            type: Number,
	            default: 0
	        }
	    },
	    computed: {
	        answers: {
	            get: function get() {
	                return this.$store.state.game.episodes[this.$store.state.game.episode - this.mod].answers;
	            }
	        }
	    },
	    methods: {
	        leave: function leave(el, done) {
	            TweenMax.fromTo(el, 0.3, { x: this.direction ? 200 : -200, opacity: 1 }, { x: this.direction ? -200 : 200, opacity: 0, onComplete: done, force3D: true }, 0.2);
	        },
	        enter: function enter(el, done) {
	            TweenMax.fromTo(el, 0.3, { x: this.direction ? 200 : -200, opacity: 0 }, { x: 0, display: 'block', opacity: 1, onComplete: done, force3D: true }, 0.2);
	        }
	    },
	    watch: {
	        'current': function current(newVal, oldVal) {
	            this.direction = newVal > oldVal;
	        }
	    }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(53);
	
	exports.default = {
	    name: 'Carousel',
	    computed: {
	        answers: {
	            get: function get() {
	                return this.$store.state.game.episodes[this.$store.state.game.episode].answers;
	            }
	        },
	        x: {
	            get: function get() {
	                return 100 * this.$store.state.carousel.active + '%';
	            }
	        }
	    },
	    methods: {
	        closeCarousel: function closeCarousel(event) {
	            var target = event.target || event.srcElement;
	            if (target.nodeName === 'LI') {
	                this.$store.dispatch('HIDE_CAROUSEL');
	            }
	        }
	    }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _iphoneInlineVideo = __webpack_require__(67);
	
	var _iphoneInlineVideo2 = _interopRequireDefault(_iphoneInlineVideo);
	
	__webpack_require__(54);
	
	var _data = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'Congrats',
	    data: function data() {
	        return {
	            endtexts: _data.endtexts,
	            text: 0,
	            reverseRanges: null,
	            disclaimer: false,
	            mobileendtext: false,
	            mobile: typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1
	        };
	    },
	    mounted: function mounted() {
	        var video_element = document.getElementById('video');
	        (0, _iphoneInlineVideo2.default)(video_element);
	        video_element.addEventListener('ended', function () {
	            video_element.webkitExitFullScreen();
	        });
	
	        if (this.mobile) {
	            video_element.controls = true;
	        } else {
	            video_element.controls = false;
	        }
	
	        // for (let i = this.ranges.length - 1; i >= 0; i--) {
	        //     const entry = this.ranges[i]
	
	        //     if (this.points >= entry) {
	        //         // this.text = i
	        //         break
	        //     }
	        // }
	
	        $('.count').each(function () {
	            $(this).prop('Counter', 0).animate({
	                Counter: $(this).text()
	            }, {
	                duration: 2000,
	                easing: 'swing',
	                step: function step(now) {
	                    $(this).text(Math.ceil(now));
	                }
	            });
	        });
	
	        if (this.maxscore - this.points <= 50) {
	            this.text = 2;
	        } else if (this.maxscore - this.points <= 100) {
	            this.text = 1;
	        } else {
	            this.text = 0;
	        }
	    },
	
	    methods: {
	        restart: function restart() {
	            var _this = this;
	
	            this.$store.dispatch('RESET_GAME').then(function () {
	                _this.$router.push('/');
	            });
	        }
	    },
	    computed: {
	        ranges: {
	            get: function get() {
	                var points = this.maxscore / _data.endtexts.length;
	                var arr = [];
	                for (var entry in _data.endtexts) {
	                    entry++;
	                    arr.push(points * entry);
	                }
	                return arr;
	            }
	        },
	        maxscore: {
	            get: function get() {
	                var actions = 0;
	                for (var episode in this.$store.state.game.episodes) {
	                    actions += this.$store.state.game.episodes[episode].actions.length;
	                }
	                return actions * _config.config.increment;
	            }
	        },
	        points: {
	            get: function get() {
	                var points = 0;
	                for (var i in this.$store.state.game.episodes) {
	                    var episode = this.$store.state.game.episodes[i];
	                    points += episode.points;
	                }
	                return points;
	            }
	        }
	    }
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(55);
	
	exports.default = {
	    name: 'Game'
	}; //
	//
	//
	//
	//
	//
	//

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(56);
	
	var _data = __webpack_require__(2);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'InfoScreen',
	    data: function data() {
	        return {
	            episode: {
	                introtext: _data.episodes[this.$store.state.game.episode].introtext
	            }
	        };
	    },
	
	    computed: {
	        points: {
	            get: function get() {
	                return this.$store.state.game.points;
	            }
	        },
	        action: {
	            get: function get() {
	                return _data.episodes[this.$store.state.game.episode].actions[this.$store.state.game.action];
	            }
	        }
	    }
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(57);
	
	var _Splash = __webpack_require__(29);
	
	var _Splash2 = _interopRequireDefault(_Splash);
	
	var _data = __webpack_require__(2);
	
	var _howler = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'Intro',
	    components: { splash: _Splash2.default },
	    data: function data() {
	        return {
	            splash: this.$store.state.game.episode === 0,
	            episode: _data.episodes[this.$store.state.game.episode],
	            prevKey: 0,
	            key: 0,
	            audio: './audio/intro.mp3',
	            mobile: false
	        };
	    },
	    mounted: function mounted() {
	        if (this.$store.state.game.episodes[this.$store.state.game.episode].answers.length === 0) {
	            this.$store.dispatch({
	                type: 'RESET_EPISODE', episode: this.$store.state.game.episode
	            });
	        }
	        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
	            this.mobile = true;
	        }
	        $('.video-container').css('display', 'none');
	        $('.intro-animation-image-container').css('display', 'none');
	
	        if (this.$store.state.game.episode !== 0) {
	            this.checkKey();
	        }
	    },
	
	    methods: {
	        startAnimation: function startAnimation() {
	            this.splash = 0;
	            this.checkKey();
	            TweenLite.set(".intro-animation-container, .intro-animation-text", { scale: 1 });
	            TweenLite.set(".intro-animation-text", { opacity: 0 });
	            TweenLite.set('.front-anim-container', { scale: 1.15 });
	            TweenLite.set('.intro-animation-image-front', { opacity: 0 });
	            if (this.episode.animation[this.key].audio != '' && this.episode.animation[this.key].type !== 'video') {
	                this.audio = new _howler.Howl({ src: this.audio });
	                this.audio.play();
	            }
	        },
	        checkKey: function checkKey() {
	            if (this.episode.animation[this.key]) {
	                this.checkSource();
	            } else {
	                this.$router.push('/introimage');
	            }
	        },
	        checkSource: function checkSource() {
	            var _this = this;
	
	            if (this.episode.animation[this.key].type === 'video') {
	                TweenLite.set(".intro-animation-text", { opacity: 0 });
	                if (this.audio != null) {
	                    if (this.audio.stop) this.audio.stop();
	                }
	
	                if (this.$mobile) {
	                    $('.video-container').css({ 'display': 'block', 'left': 0, 'right': 0, 'top': 0, 'bottom': 0 });
	                } else {
	                    $('.video-container').css({ 'display': 'block' });
	                }
	
	                $('.intro-animation-image-container').css('display', 'none');
	
	                if (this.episode.animation[this.key].text) {
	                    TweenLite.to(".intro-animation-text", 0.5, { opacity: 1, delay: 1 });
	                }
	
	                var video_element = document.getElementById('video');
	
	                setTimeout(function () {
	                    var vid_duration = document.getElementById('video').duration;
	                    TweenLite.to(".intro-animation-text", 0.5, { opacity: 0, delay: vid_duration - 1 });
	                }, 1000);
	
	                if (this.mobile) {
	                    video_element.controls = true;
	                } else {
	                    video_element.controls = false;
	                }
	
	                video_element.addEventListener('ended', function () {
	                    _this.key++;
	                    _this.checkKey();
	                });
	            } else {
	                this.animateImage();
	            }
	        },
	        animateImage: function animateImage() {
	            var _this2 = this;
	
	            if (this.$mobile) {
	                $('.intro-animation-image-container').css({ 'display': 'none', 'left': 0, 'right': 0, 'top': 0, 'bottom': 0 });
	                $('.intro-animation-text').css({ 'font-size': '20px', 'line-height': '30px', 'padding': '10px 15px' });
	            }
	            TweenLite.to(".intro-animation-text", 0.5, { opacity: 1, delay: 0.5 }
	            // if (this.episode.animation[this.key].audio != '' && this.episode.animation[this.key].type !== 'video' && this.$store.state.game.episode !== 0){
	            //     this.audio = new Howl ({src: this.episode.animation[this.key].audio});
	            //     this.audio.play();
	            // }
	            );$('.video-container').css('display', 'none');
	            $('.intro-animation-image-container').css('display', 'block');
	
	            TweenLite.set('.front-anim-container', { scale: 1.15 });
	
	            TweenLite.set('.back-anim-container', { scale: 1 });
	            TweenLite.to('.intro-animation-image-front', 2, { opacity: 0, onComplete: function onComplete() {
	                    if (_this2.key > 0) {
	                        _this2.prevKey++;
	                    }
	                    TweenLite.to(".intro-animation-text", 0.5, { opacity: 0, delay: 1.5 });
	                } });
	
	            TweenLite.to('.back-anim-container', 3.5, { delay: 0.2, scale: 1.15 });
	            TweenLite.to('.intro-animation-image-front', 0.5, { delay: 3.5, opacity: 1, onComplete: function onComplete() {
	                    _this2.key++;
	                    _this2.checkKey();
	                } });
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        if (this.audio != null) {
	            if (this.audio.stop) this.audio.stop();
	        }
	    }
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(58);
	
	var _data = __webpack_require__(2);
	
	var _howler = __webpack_require__(19);
	
	__webpack_require__(10);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'IntroImage',
	    data: function data() {
	        return {
	            episode: {
	                introImageText: _data.episodes[this.$store.state.game.episode].introImageText,
	                introImage: _data.episodes[this.$store.state.game.episode].introImage
	            },
	            unlock: null
	        };
	    },
	    mounted: function mounted() {
	        var buzz = new _howler.Howl({ src: 'audio/PhoneVibrate.mp3' });
	        this.unlock = new _howler.Howl({ src: 'audio/iPhoneUnlockSound.mp3' });
	        var that = this;
	
	        if (this.$mobile) {
	            $('.image-intro').css('height', '300px');
	            $('.intro-image .img-container').css('margin-left', '-30px');
	            $('.intro-image .img-container a').css({ 'left': '49%', 'bottom': '22px', 'width': '90px', 'height': '90px' });
	            $('.title-02').css('font-size', '1.3em');
	            $('.intro-text-box').css({ 'padding': '20px', 'min-height': '100px' });
	        }
	
	        this.tlBuzz = new TimelineLite();
	        this.tlBuzz.to(".animation-container", 0.45, { rotation: 1, ease: "buzz", delay: 1, transformOrigin: "50% 50%", onStart: function onStart() {
	                buzz.play();
	            } }).to(".animation-container", 0.45, { rotation: 1, ease: "buzz", transformOrigin: "50% 50%" }).to(".animation-container", 1, { delay: 0.5, onComplete: function onComplete() {
	                that.tlBuzz.restart();
	            } });
	
	        $(".link").hover(function () {
	            TweenLite.to(".link", 0.3, { scale: 1.1, force3D: true });
	        }, function () {
	            TweenLite.to(".link", 0.3, { scale: 1, force3D: true });
	        });
	    },
	
	    methods: {
	        playClick: function playClick() {
	            this.unlock.play();
	            this.$router.push('/vraag');
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.tlBuzz.stop();
	    }
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Answers = __webpack_require__(28);
	
	var _Answers2 = _interopRequireDefault(_Answers);
	
	var _AnswersSlideshow = __webpack_require__(101);
	
	var _AnswersSlideshow2 = _interopRequireDefault(_AnswersSlideshow);
	
	var _data = __webpack_require__(2);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'Overview',
	    components: {
	        Answers: _Answers2.default, AnswersSlideshow: _AnswersSlideshow2.default
	    },
	    data: function data() {
	        return {
	            episode: this.$store.state.game.episodes[this.$store.state.game.episode],
	            response: 'GOED GEDAAN!',
	            mod: 0,
	            questionToggle: false
	        };
	    },
	
	    methods: {
	        slideoutQuestion: function slideoutQuestion() {
	            var _this = this;
	
	            TweenLite.to('.introtext', 0.4, { y: -300, opacity: 0, force3D: true, onComplete: function onComplete() {
	                    _this.questionToggle = false;
	                } });
	        },
	        slideinQuestion: function slideinQuestion() {
	            TweenLite.fromTo('.introtext', 0.4, { y: -300, opacity: 0 }, { y: '-50%', opacity: 1, force3D: true });
	        },
	        toggleQuestion: function toggleQuestion() {
	            if (this.questionToggle) {
	                this.setupQuestionToggle();
	            } else {
	                this.questionToggle = !this.questionToggle;
	            }
	        },
	        setupQuestionToggle: function setupQuestionToggle() {
	            var _this2 = this;
	
	            TweenLite.to('.introtext', 0.4, { y: -300, opacity: 0, force3D: true, onComplete: function onComplete() {
	                    _this2.questionToggle = false;
	                } });
	        },
	        proceed: function proceed() {
	            var _this3 = this;
	
	            var next = this.$store.state.game.episode + 1;
	            var mayProceed = this.$store.state.game.episodes[this.$store.state.game.episode].answers.length;
	            if (mayProceed) {
	                this.$store.dispatch('UNLOCK_EPISODE', { episode: next }).then(function () {
	                    TweenLite.to('.main-bg-image', 0.5, { opacity: 0, onComplete: function onComplete() {
	                            _this3.$store.dispatch('CHANGE_EPISODE', { episode: next });
	                            _this3.$router.push('/tijdlijn');
	                        } });
	                });
	            } else {
	                this.$router.push('/tijdlijn');
	            }
	        }
	    },
	    computed: {
	        points: {
	            get: function get() {
	                var points = 0;
	                for (var i in this.$store.state.game.episodes) {
	                    var episode = this.$store.state.game.episodes[i];
	                    points += episode.points;
	                }
	                return points;
	            }
	        },
	        pointResponse: {
	            get: function get() {
	                var pointResponse = '';
	                if (this.episode.points >= this.episode.actions.length * 10 / 2) {
	                    pointResponse = 'GOED GEDAAN!';
	                }
	
	                return pointResponse;
	            }
	        }
	    },
	    beforeMount: function beforeMount() {
	        var correctEpisode = this.$store.state.game.episodes[this.$store.state.game.episode].answers.length;
	        if (!correctEpisode) {
	            this.mod = 1;
	            this.episode = this.$store.state.game.episodes[this.$store.state.game.episode - 1];
	        }
	    },
	    mounted: function mounted() {
	        if (this.$mobile) {
	            $('.main-bg-cover').css('z-index', '-1');
	            $('.main-bg-image').hide();
	            $('.introtext-container').css('height', '100%');
	            $('.introtext').css({
	                'top': '50%',
	                'position': 'relative',
	                'transform': 'translateY(-50%)',
	                'font-size': '0.9em'
	            });
	            $('.introtext a').hide();
	        }
	        $('.count').each(function () {
	            $(this).prop('Counter', 0).animate({
	                Counter: $(this).text()
	            }, {
	                duration: 1000,
	                easing: 'swing',
	                step: function step(now) {
	                    $(this).text(Math.ceil(now));
	                }
	            });
	        });
	    }
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Answers = __webpack_require__(28);
	
	var _Answers2 = _interopRequireDefault(_Answers);
	
	__webpack_require__(60);
	
	var _data = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// { } here is destructuring: basically we just import episodes from the index.js in the data directory and nother else. You can extend what you import by adding stuff to it: e.g. 'import { episodes, somethingelse } from ...'
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'Question',
	    data: function data() {
	        return {
	            episode: this.$store.state.game.episodes[this.$store.state.game.episode],
	            total: this.$store.state.game.episodes[this.$store.state.game.episode].actions.length,
	            intro: this.$store.state.game.episodes[this.$store.state.game.episode].intro,
	            feedback: this.$store.state.game.episodes[this.$store.state.game.episode].feedback,
	            showFeedback: false,
	            correct: false,
	            config: _config.config,
	            top: 0,
	            answer: null,
	            questionToggle: null
	        };
	    },
	    mounted: function mounted() {
	        TweenLite.set(".explosion-container", { scale: 0.75 });
	        if (this.$mobile) {
	            this.episode.introtext += '<a class="button mobile"> OK</a>';
	            $('.main-bg-cover').css('z-index', '-1');
	            $('.main-bg-image').hide();
	            $('.introtext-container').css('height', '100%');
	            $('.introtext').css({
	                'top': '50%',
	                'position': 'relative',
	                'transform': 'translateY(-50%)',
	                'font-size': '1em'
	            });
	        }
	    },
	
	    components: {
	        Answers: _Answers2.default
	    },
	    computed: {
	        points: {
	            get: function get() {
	                var points = 0;
	                for (var i in this.$store.state.game.episodes) {
	                    var episode = this.$store.state.game.episodes[i];
	                    points += episode.points;
	                }
	                return points;
	            }
	        },
	        action: {
	            get: function get() {
	                return this.episode.actions[this.$store.state.game.action];
	            }
	        }
	    },
	    methods: {
	        slideoutQuestion: function slideoutQuestion() {
	            var _this = this;
	
	            TweenLite.to('.introtext', 0.4, { y: -300, opacity: 0, force3D: true, onComplete: function onComplete() {
	                    _this.questionToggle = false;
	                } });
	        },
	        slideinQuestion: function slideinQuestion() {
	            TweenLite.fromTo('.introtext', 0.4, { y: -300, opacity: 0 }, { y: '-50%', opacity: 1, force3D: true });
	        },
	        toggleQuestion: function toggleQuestion() {
	            if (this.questionToggle) {
	                this.setupQuestionToggle();
	            } else {
	                this.questionToggle = !this.questionToggle;
	            }
	        },
	        setupQuestionToggle: function setupQuestionToggle() {
	            var _this2 = this;
	
	            TweenLite.to('.introtext', 0.4, { y: -300, opacity: 0, force3D: true, onComplete: function onComplete() {
	                    _this2.questionToggle = false;
	                } });
	        },
	        processAction: function processAction(answer) {
	            var _this3 = this;
	
	            this.answer = answer;
	            var i = answer === this.action.answer ? _config.config.increment : _config.config.decrement;
	
	            this.$store.dispatch('CHANGE_POINTS', { points: i }).then(function () {
	                answer = {
	                    action: _this3.$store.state.game.action,
	                    answer: _config.config[answer],
	                    question: _this3.action.title,
	                    episode: _this3.$store.state.game.episode,
	                    points: i
	                };
	                _this3.$store.dispatch('ADD_ANSWER', { answer: answer });
	                _this3.showFeedback = true;
	                TweenLite.set('.feedback-container', { height: 0, opacity: 0, force3D: true });
	                TweenLite.to('.feedback-container', 0.3, { height: 'auto', opacity: 1, delay: 0.5, force3D: true });
	                _this3.correct = answer.points;
	                if (_this3.correct != 0) {
	                    // TweenLite.set('.particles', {scale:0, opacity:0})
	                    // TweenLite.to('.particles', 1, {rotation:33, scale:1, opacity:1, ease:'glow', force3D: true, transformOrigin:'38% 67%'})
	                    // TweenLite.to(".points-container", 0.75, {scale:1.1, ease:'glow', force3D: true, transformOrigin:'20% 50%'});
	                    _this3.explode();
	                }
	            });
	        },
	        explode: function explode() {
	            var animspeed = 0.45;
	
	            TweenLite.set(".anim-container", { opacity: 0 });
	
	            TweenLite.set(".bolts", { rotation: 0 });
	            TweenLite.set(".halos", { rotation: 0 });
	
	            TweenLite.set(".bolt1", { rotation: 72, x: 40, y: 70, scale: 0.1 });
	            TweenLite.set(".bolt2", { rotation: 144, x: 70, y: 50, scale: 0.1 });
	            TweenLite.set(".bolt3", { rotation: 216, x: 70, y: 50, scale: 0.1 });
	            TweenLite.set(".bolt4", { rotation: 288, x: 40, y: 30, scale: 0.1 });
	            TweenLite.set(".bolt5", { rotation: 0, x: 20, y: -20, scale: 0.1 });
	
	            TweenLite.set(".halo1", { rotation: 0, x: 50, y: 60, scale: 0.1 });
	            TweenLite.set(".halo2", { rotation: 30, x: 60, y: 0, scale: 0.1 });
	            TweenLite.set(".halo3", { rotation: 240, x: 40, y: -70, scale: 0.1 });
	
	            TweenLite.set(".brick1", { x: 50, y: 50, scale: 0.1 });
	            TweenLite.set(".brick2", { x: 50, y: -50, scale: 0.1 });
	
	            TweenLite.to(".anim-container", animspeed / 2, { opacity: 1 });
	
	            TweenLite.to(".bolts", animspeed, { rotation: 25 });
	            TweenLite.to(".halos", animspeed, { rotation: -25 });
	
	            TweenLite.to(".bolt1", animspeed, { x: 30, y: 10, scale: 1 });
	            TweenLite.to(".bolt2", animspeed, { x: 180, y: -20, scale: 1 });
	            TweenLite.to(".bolt3", animspeed, { x: 140, y: 100, scale: 1 });
	            TweenLite.to(".bolt4", animspeed, { x: 20, y: 100, scale: 1 });
	            TweenLite.to(".bolt5", animspeed, { x: -50, y: -20, scale: 1 });
	
	            TweenLite.to(".halo1", animspeed, { x: 50, y: 0, scale: 1 });
	            TweenLite.to(".halo2", animspeed, { x: 100, y: -40, scale: 1 });
	            TweenLite.to(".halo3", animspeed, { x: -20, y: 0, scale: 1.5 });
	
	            TweenLite.to(".brick1", animspeed, { rotation: 50, x: 200, y: -100, scale: 1 });
	            TweenLite.to(".brick2", animspeed, { rotation: 50, x: 200, y: 0, scale: 1 });
	
	            TweenLite.to(".anim-container", animspeed, { opacity: 0, delay: animspeed / 2 });
	        },
	        nextAction: function nextAction() {
	            var _this4 = this;
	
	            TweenLite.to('.question-action-title', 0.1, { opacity: 0 });
	            TweenLite.to('.feedback-container', 0.3, { height: 0, opacity: 0, force3D: true, onComplete: function onComplete() {
	                    _this4.showFeedback = false;
	                } });
	            this.answer = null;
	            this.$store.dispatch('NEXT_ACTION').then(function (response) {
	                TweenLite.to('.question-action-title', 0.5, { delay: 0.3, opacity: 1 });
	                if (!response) {
	                    _this4.$router.push('/overzicht');
	                }
	            });
	        }
	    }
	};
	
	// import css for this component

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(61);
	
	__webpack_require__(10);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'Splash',
	    methods: {
	        start: function start() {
	            // this.$router.push('/intro')
	        }
	    },
	    mounted: function mounted() {
	
	        if (this.$mobile) {
	            TweenLite.set(".link-image", { opacity: 0, scale: 1, rotation: 1, force3D: true });
	            TweenLite.to(".link-image", 0.4, { opacity: 1, scale: 0.5, rotation: -1, force3D: true, delay: 1, ease: Back.easeOut.config(1.7) });
	        } else {
	            TweenLite.set(".link-image", { opacity: 0, scale: 1.5, rotation: 1, force3D: true });
	            TweenLite.to(".link-image", 0.4, { opacity: 1, scale: 1, rotation: -1, force3D: true, delay: 1, ease: Back.easeOut.config(1.7) });
	        }
	
	        TweenLite.to(".circle", 0.4, { scale: 1.05, delay: 2, force3D: true, ease: "blink" });
	
	        $(".link").hover(function () {
	            TweenLite.to(".circle", 0.1, { scale: 1.05 });
	            TweenLite.to(".arrow", 0.3, { x: 30, opacity: 0, ease: Power1.easeOut });
	            TweenLite.set(".arrow", { x: -50, opacity: 0, delay: 0.3 });
	            TweenLite.to(".arrow", 0.3, { x: "-30%", opacity: 1, delay: 0.3, ease: Power1.easeOut });
	        }, function () {
	            TweenLite.to(".circle", 0.1, { scale: 1 });
	        });
	    }
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(62);
	
	var _data = __webpack_require__(2);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'Timeline',
	    data: function data() {
	        return {
	            episodes: _data.episodes,
	            episodeWidth: $(window).innerWidth() / 3 - 80,
	            activeEp: 0
	        };
	    },
	    mounted: function mounted() {
	
	        TweenLite.to('.main-bg-image', 0.5, { opacity: 1 });
	
	        var that = this;
	        $(window).resize(function () {
	            $(".episode").each(function (index, element) {
	                if ($(element).hasClass("active")) {
	                    that.slide();
	                    return false;
	                }
	            });
	            that.episodeWidth = $(window).innerWidth() / 3 - 80;
	            that.width();
	        });
	        var lastComplete = $('.complete .thumbnail-container').slice(-1)[0];
	        $(lastComplete).append('<div class="active-state"></div>');
	        $('.active .thumbnail-container').append('<div class="locked-state"></div>');
	        TweenLite.set($(lastComplete).find('.state'), { opacity: 0, scale: 0 });
	        TweenLite.set('.active .state', { x: '-50%', y: '-50%', opacity: 0, scale: 0 });
	
	        var epnr = 0;
	        $(".episode").each(function (index, element) {
	            if ($(element).hasClass("active")) {
	                TweenLite.set(".episodes", { x: -(index - 2) * $(window).innerWidth() / 3 });
	                that.activeEp = index;
	
	                TweenLite.to('.active-state', 0.5, { opacity: 0, delay: 0.5 });
	                TweenLite.to('.complete .state', 0.5, { opacity: 1, delay: 0.6, scale: 1, ease: Back.easeOut.config(1.7), onComplete: function onComplete() {
	                        $('.active-state').remove();
	                        that.slide();
	
	                        TweenLite.to('.locked-state', 0.5, { opacity: 0, delay: 1 });
	                        TweenLite.to('.active', 1, { scale: 1.3 });
	                        TweenLite.to('.active .state', 0.5, { opacity: 1, delay: 1.3, scale: 1, ease: Back.easeOut.config(1.7), onComplete: function onComplete() {
	                                $('.locked-state').remove();
	                            } });
	                    } });
	
	                return false;
	            } else if ($(element).not("active") && $(element).not("complete")) {
	                $(element).addClass('complete');
	                $($('.pagination-bullet')[epnr]).addClass('complete');
	            }
	            epnr++;
	        });
	
	        if ($(".episode").length == $(".complete").length / 2) {
	            this.$router.push('/uitspraak');
	        } else {
	            if ($(".active").hasClass('complete') || $(".active").hasClass('locked') || $(".complete").hasClass('locked')) {
	                $(".active").removeClass('locked');
	                $(".active").removeClass('complete');
	                $(".complete").removeClass('locked');
	            }
	        }
	
	        $(".active").hover(function () {
	            TweenLite.to($(this).find(".state"), 0.3, { backgroundPositionX: '200%', ease: Power1.easeOut });
	            TweenLite.set($(this).find(".state"), { backgroundPositionX: '-200%', delay: 0.3 });
	            TweenLite.to($(this).find(".state"), 0.3, { backgroundPositionX: '60%', ease: Power1.easeOut, delay: 0.3 });
	        }, function () {});
	    },
	
	    methods: {
	        startEpisode: function startEpisode(episode) {
	            if (episode === this.$store.state.game.episode) {
	                this.$router.push('/');
	            } else if (this.$store.state.debugmode) {
	                this.$store.dispatch('CHANGE_EPISODE', { episode: episode });
	                this.$router.push('/');
	            }
	        },
	        width: function width() {
	            return this.episodeWidth + 'px';
	        },
	        slideLeft: function slideLeft() {
	            if (this.activeEp > 0) {
	                this.activeEp--;
	                this.slide();
	            }
	        },
	        slideRight: function slideRight() {
	            if (this.activeEp < $(".episode").length - 1) {
	                this.activeEp++;
	                this.slide();
	            }
	        },
	        slide: function slide() {
	
	            var slidePos = 0;
	
	            if (this.activeEp === 0) {
	                slidePos = $(window).innerWidth() / 3;
	            } else {
	                slidePos = -($(window).innerWidth() / 3) * this.activeEp + $(window).innerWidth() / 3;
	            }
	
	            TweenLite.to(".episodes", 1, { delay: 0.1, x: slidePos });
	
	            this.updatePagination();
	        },
	        updatePagination: function updatePagination() {
	            var paginationActive = $('.pagination-bullet')[this.activeEp];
	            var episodeActive = $('.episode')[this.activeEp];
	            $('.pagination-bullet').removeClass('highlighted');
	            $(paginationActive).addClass('highlighted');
	            TweenLite.to('.episode', 1, { scale: 1.2 });
	            TweenLite.to(episodeActive, 1, { scale: 1.4 });
	        }
	    },
	    computed: {
	        points: {
	            get: function get() {
	                var points = 0;
	                for (var i in this.$store.state.game.episodes) {
	                    var episode = this.$store.state.game.episodes[i];
	                    points += episode.points;
	                }
	                return points;
	            }
	        }
	    }
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(63);
	
	var _data = __webpack_require__(2);
	
	__webpack_require__(10);
	
	exports.default = {
	    name: 'verdictScreen',
	    data: function data() {
	        return {};
	    },
	    mounted: function mounted() {},
	
	    methods: {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mobileDetect = __webpack_require__(69);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function iOSversion() {
	    if (/iP(hone|od|ad)/.test(navigator.platform)) {
	        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
	    }
	}
	
	var md = new _mobileDetect2.default(window.navigator.userAgent);
	var mob = false;
	var tablet = false;
	if (md.mobile() && md.phone()) {
	    mob = true;
	    if (md.is('iPhone')) {
	        document.body.style.height = '105vh';
	    }
	} else if (md.mobile() && md.tablet()) {
	    tablet = true;
	}
	
	window.mobile = mob;
	_vue2.default.mixin({
	    created: function created() {
	        this.$mobile = mob;
	        this.$tablet = tablet;
	    }
	});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Splash = __webpack_require__(29);
	
	var _Splash2 = _interopRequireDefault(_Splash);
	
	var _Intro = __webpack_require__(106);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _IntroImage = __webpack_require__(107);
	
	var _IntroImage2 = _interopRequireDefault(_IntroImage);
	
	var _InfoScreen = __webpack_require__(105);
	
	var _InfoScreen2 = _interopRequireDefault(_InfoScreen);
	
	var _Question = __webpack_require__(109);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _Game = __webpack_require__(104);
	
	var _Game2 = _interopRequireDefault(_Game);
	
	var _Overview = __webpack_require__(108);
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	var _Timeline = __webpack_require__(110);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _Congrats = __webpack_require__(103);
	
	var _Congrats2 = _interopRequireDefault(_Congrats);
	
	var _verdictScreen = __webpack_require__(111);
	
	var _verdictScreen2 = _interopRequireDefault(_verdictScreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{ path: '/', component: _Intro2.default, meta: { scrollTop: 0 } },
	// { path: '/intro', component: Intro, meta: { scrollTop: 50 }},
	{ path: '/introimage', component: _IntroImage2.default, meta: { scrollTop: 10 } }, { path: '/infoscreen', component: _InfoScreen2.default, meta: { scrollTop: 0 } }, { path: '/vraag', component: _Question2.default, meta: { scrollTop: 0 } }, { path: '/spel', component: _Game2.default, meta: { scrollTop: 0 } }, { path: '/overzicht', component: _Overview2.default, meta: { scrollTop: 0 } }, { path: '/tijdlijn', component: _Timeline2.default, meta: { scrollTop: 0 } }, { path: '/gefeliciteerd', component: _Congrats2.default, meta: { scrollTop: 0 } }, { path: '/uitspraak', component: _verdictScreen2.default, meta: { scrollTop: 0 } }, { path: '*', component: _Intro2.default, meta: { scrollTop: 0 } }];
	
	exports.default = routes;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(6);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(16);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(47);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	    mode: 'hash',
	    base: __dirname,
	    transitionOnLoad: true,
	    linkActiveClass: 'active',
	    routes: _routes2.default
	});
	
	var debug_url = '/debugmode';
	
	router.beforeEach(function (route, redirect, next) {
	    if (route.path === '/vraag') {
	        if (_store2.default.state.game.episodes[_store2.default.state.game.episode].points && _store2.default.state.game.episodes[_store2.default.state.game.episode].answers.length === _store2.default.state.game.episodes[_store2.default.state.game.episode].actions.length) {
	            return router.push('/overzicht');
	        }
	    }
	    if (route.path === debug_url) {
	        _store2.default.dispatch('ENABLE_DEBUGMODE').then(function () {
	            router.push('/tijdlijn');
	        });
	    } else {
	        var firstEpisodeOnly = ['/introimage', '/infoscreen'];
	        if (_store2.default.state.game.episode > 0 && firstEpisodeOnly.indexOf(route.path) != -1) {
	            return router.push('/vraag');
	        }
	        next();
	    }
	});
	
	router.afterEach(function (route, redirect) {
	    if (window.mobile && route.path !== '/') {
	        setTimeout(function () {
	            window.scrollTo(0, route.meta.scrollTop);
	        }, 500);
	    }
	});
	
	exports.default = router;
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(50)();
	// imports
	
	
	// module
	exports.push([module.id, ".sound-warning{position:absolute;right:-40%;bottom:7%}", ""]);
	
	// exports


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	/*! npm.im/intervalometer */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function intervalometer(cb, request, cancel, requestParameter) {
		var requestId;
		var previousLoopTime;
		function loop(now) {
			// must be requested before cb() because that might call .stop()
			requestId = request(loop, requestParameter);
	
			// called with "ms since last call". 0 on start()
			cb(now - (previousLoopTime || now));
	
			previousLoopTime = now;
		}
		return {
			start: function start() {
				if (!requestId) { // prevent double starts
					loop(0);
				}
			},
			stop: function stop() {
				cancel(requestId);
				requestId = null;
				previousLoopTime = 0;
			}
		};
	}
	
	function frameIntervalometer(cb) {
		return intervalometer(cb, requestAnimationFrame, cancelAnimationFrame);
	}
	
	function timerIntervalometer(cb, delay) {
		return intervalometer(cb, setTimeout, clearTimeout, delay);
	}
	
	exports.intervalometer = intervalometer;
	exports.frameIntervalometer = frameIntervalometer;
	exports.timerIntervalometer = timerIntervalometer;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/*! npm.im/iphone-inline-video 2.2.2 */
	'use strict';
	
	var intervalometer = __webpack_require__(66);
	
	function preventEvent(element, eventName, test) {
		function handler(e) {
			if (!test || test(element, eventName)) {
				e.stopImmediatePropagation();
				// // console.log(eventName, 'prevented on', element);
			}
		}
		element.addEventListener(eventName, handler);
	
		// Return handler to allow to disable the prevention. Usage:
		// const preventionHandler = preventEvent(el, 'click');
		// el.removeEventHandler('click', preventionHandler);
		return handler;
	}
	
	function proxyProperty(object, propertyName, sourceObject, copyFirst) {
		function get() {
			return sourceObject[propertyName];
		}
		function set(value) {
			sourceObject[propertyName] = value;
		}
	
		if (copyFirst) {
			set(object[propertyName]);
		}
	
		Object.defineProperty(object, propertyName, {get: get, set: set});
	}
	
	function proxyEvent(object, eventName, sourceObject) {
		sourceObject.addEventListener(eventName, function () { return object.dispatchEvent(new Event(eventName)); });
	}
	
	function dispatchEventAsync(element, type) {
		Promise.resolve().then(function () {
			element.dispatchEvent(new Event(type));
		});
	}
	
	var iOS8or9 = typeof document === 'object' && 'object-fit' in document.head.style && !matchMedia('(-webkit-video-playable-inline)').matches;
	
	var IIV = 'bfred-it:iphone-inline-video';
	var IIVEvent = 'bfred-it:iphone-inline-video:event';
	var IIVPlay = 'bfred-it:iphone-inline-video:nativeplay';
	var IIVPause = 'bfred-it:iphone-inline-video:nativepause';
	
	/**
	 * UTILS
	 */
	
	function getAudioFromVideo(video) {
		var audio = new Audio();
		proxyEvent(video, 'play', audio);
		proxyEvent(video, 'playing', audio);
		proxyEvent(video, 'pause', audio);
		audio.crossOrigin = video.crossOrigin;
	
		// 'data:' causes audio.networkState > 0
		// which then allows to keep <audio> in a resumable playing state
		// i.e. once you set a real src it will keep playing if it was if .play() was called
		audio.src = video.src || video.currentSrc || 'data:';
	
		// // if (audio.src === 'data:') {
		//   TODO: wait for video to be selected
		// // }
		return audio;
	}
	
	var lastRequests = [];
	var requestIndex = 0;
	var lastTimeupdateEvent;
	
	function setTime(video, time, rememberOnly) {
		// Allow one timeupdate event every 200+ ms
		if ((lastTimeupdateEvent || 0) + 200 < Date.now()) {
			video[IIVEvent] = true;
			lastTimeupdateEvent = Date.now();
		}
		if (!rememberOnly) {
			video.currentTime = time;
		}
		lastRequests[++requestIndex % 3] = time * 100 | 0 / 100;
	}
	
	function isPlayerEnded(player) {
		return player.driver.currentTime >= player.video.duration;
	}
	
	function update(timeDiff) {
		var player = this;
		// // console.log('update', player.video.readyState, player.video.networkState, player.driver.readyState, player.driver.networkState, player.driver.paused);
		if (player.video.readyState >= player.video.HAVE_FUTURE_DATA) {
			if (!player.hasAudio) {
				player.driver.currentTime = player.video.currentTime + ((timeDiff * player.video.playbackRate) / 1000);
				if (player.video.loop && isPlayerEnded(player)) {
					player.driver.currentTime = 0;
				}
			}
			setTime(player.video, player.driver.currentTime);
		} else if (player.video.networkState === player.video.NETWORK_IDLE && player.video.buffered.length === 0) {
			// This should happen when the source is available but:
			// - it's potentially playing (.paused === false)
			// - it's not ready to play
			// - it's not loading
			// If it hasAudio, that will be loaded in the 'emptied' handler below
			player.video.load();
			// // console.log('Will load');
		}
	
		// // console.assert(player.video.currentTime === player.driver.currentTime, 'Video not updating!');
	
		if (player.video.ended) {
			delete player.video[IIVEvent]; // Allow timeupdate event
			player.video.pause(true);
		}
	}
	
	/**
	 * METHODS
	 */
	
	function play() {
		// // console.log('play');
		var video = this;
		var player = video[IIV];
	
		// If it's fullscreen, use the native player
		if (video.webkitDisplayingFullscreen) {
			video[IIVPlay]();
			return;
		}
	
		if (player.driver.src !== 'data:' && player.driver.src !== video.src) {
			// // console.log('src changed on play', video.src);
			setTime(video, 0, true);
			player.driver.src = video.src;
		}
	
		if (!video.paused) {
			return;
		}
		player.paused = false;
	
		if (video.buffered.length === 0) {
			// .load() causes the emptied event
			// the alternative is .play()+.pause() but that triggers play/pause events, even worse
			// possibly the alternative is preventing this event only once
			video.load();
		}
	
		player.driver.play();
		player.updater.start();
	
		if (!player.hasAudio) {
			dispatchEventAsync(video, 'play');
			if (player.video.readyState >= player.video.HAVE_ENOUGH_DATA) {
				// // console.log('onplay');
				dispatchEventAsync(video, 'playing');
			}
		}
	}
	function pause(forceEvents) {
		// // console.log('pause');
		var video = this;
		var player = video[IIV];
	
		player.driver.pause();
		player.updater.stop();
	
		// If it's fullscreen, the developer the native player.pause()
		// This is at the end of pause() because it also
		// needs to make sure that the simulation is paused
		if (video.webkitDisplayingFullscreen) {
			video[IIVPause]();
		}
	
		if (player.paused && !forceEvents) {
			return;
		}
	
		player.paused = true;
		if (!player.hasAudio) {
			dispatchEventAsync(video, 'pause');
		}
	
		// Handle the 'ended' event only if it's not fullscreen
		if (video.ended && !video.webkitDisplayingFullscreen) {
			video[IIVEvent] = true;
			dispatchEventAsync(video, 'ended');
		}
	}
	
	/**
	 * SETUP
	 */
	
	function addPlayer(video, hasAudio) {
		var player = {};
		video[IIV] = player;
		player.paused = true; // Track whether 'pause' events have been fired
		player.hasAudio = hasAudio;
		player.video = video;
		player.updater = intervalometer.frameIntervalometer(update.bind(player));
	
		if (hasAudio) {
			player.driver = getAudioFromVideo(video);
		} else {
			video.addEventListener('canplay', function () {
				if (!video.paused) {
					// // console.log('oncanplay');
					dispatchEventAsync(video, 'playing');
				}
			});
			player.driver = {
				src: video.src || video.currentSrc || 'data:',
				muted: true,
				paused: true,
				pause: function () {
					player.driver.paused = true;
				},
				play: function () {
					player.driver.paused = false;
					// Media automatically goes to 0 if .play() is called when it's done
					if (isPlayerEnded(player)) {
						setTime(video, 0);
					}
				},
				get ended() {
					return isPlayerEnded(player);
				}
			};
		}
	
		// .load() causes the emptied event
		video.addEventListener('emptied', function () {
			// // console.log('driver src is', player.driver.src);
			var wasEmpty = !player.driver.src || player.driver.src === 'data:';
			if (player.driver.src && player.driver.src !== video.src) {
				// // console.log('src changed to', video.src);
				setTime(video, 0, true);
				player.driver.src = video.src;
				// Playing videos will only keep playing if no src was present when .play()’ed
				if (wasEmpty || (!hasAudio && video.autoplay)) {
					player.driver.play();
				} else {
					player.updater.stop();
				}
			}
		}, false);
	
		// Stop programmatic player when OS takes over
		video.addEventListener('webkitbeginfullscreen', function () {
			if (!video.paused) {
				// Make sure that the <audio> and the syncer/updater are stopped
				video.pause();
	
				// Play video natively
				video[IIVPlay]();
			} else if (hasAudio && player.driver.buffered.length === 0) {
				// If the first play is native,
				// the <audio> needs to be buffered manually
				// so when the fullscreen ends, it can be set to the same current time
				player.driver.load();
			}
		});
		if (hasAudio) {
			video.addEventListener('webkitendfullscreen', function () {
				// Sync audio to new video position
				player.driver.currentTime = video.currentTime;
				// // console.assert(player.driver.currentTime === video.currentTime, 'Audio not synced');
			});
	
			// Allow seeking
			video.addEventListener('seeking', function () {
				if (lastRequests.indexOf(video.currentTime * 100 | 0 / 100) < 0) {
					// // console.log('User-requested seeking');
					player.driver.currentTime = video.currentTime;
				}
			});
		}
	}
	
	function preventWithPropOrFullscreen(el) {
		var isAllowed = el[IIVEvent];
		delete el[IIVEvent];
		return !el.webkitDisplayingFullscreen && !isAllowed;
	}
	
	function overloadAPI(video) {
		var player = video[IIV];
		video[IIVPlay] = video.play;
		video[IIVPause] = video.pause;
		video.play = play;
		video.pause = pause;
		proxyProperty(video, 'paused', player.driver);
		proxyProperty(video, 'muted', player.driver, true);
		proxyProperty(video, 'playbackRate', player.driver, true);
		proxyProperty(video, 'ended', player.driver);
		proxyProperty(video, 'loop', player.driver, true);
	
		// IIV works by seeking 60 times per second.
		// These events are now useless.
		preventEvent(video, 'seeking', function (el) { return !el.webkitDisplayingFullscreen; });
		preventEvent(video, 'seeked', function (el) { return !el.webkitDisplayingFullscreen; });
	
		// Limit timeupdate events
		preventEvent(video, 'timeupdate', preventWithPropOrFullscreen);
	
		// Prevent occasional native ended events
		preventEvent(video, 'ended', preventWithPropOrFullscreen);
	}
	
	function enableInlineVideo(video, opts) {
		if ( opts === void 0 ) opts = {};
	
		// Stop if already enabled
		if (video[IIV]) {
			return;
		}
	
		// Allow the user to skip detection
		if (!opts.everywhere) {
			// Only iOS8 and 9 are supported
			if (!iOS8or9) {
				return;
			}
	
			// Stop if it's not an allowed device
			if (!(opts.iPad || opts.ipad ? /iPhone|iPod|iPad/ : /iPhone|iPod/).test(navigator.userAgent)) {
				return;
			}
		}
	
		// Try to pause
		video.pause();
	
		// Prevent autoplay.
		// An non-started autoplaying video can't be .pause()'d
		var willAutoplay = video.autoplay;
		video.autoplay = false;
	
		addPlayer(video, !video.muted);
		overloadAPI(video);
		video.classList.add('IIV');
	
		// Autoplay
		if (video.muted && willAutoplay) {
			video.play();
			video.addEventListener('playing', function restoreAutoplay() {
				video.autoplay = true;
				video.removeEventListener('playing', restoreAutoplay);
			});
		}
	
		if (!/iPhone|iPod|iPad/.test(navigator.platform)) {
			console.warn('iphone-inline-video is not guaranteed to work in emulated environments');
		}
	}
	
	module.exports = enableInlineVideo;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.2.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2017-03-20T18:59Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.2.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( ">tbody", elem )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with computed style
		var valueIsBorderBox,
			styles = getStyles( elem ),
			val = curCSS( elem, name, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );
	
		// Fall back to offsetWidth/Height when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		if ( val === "auto" ) {
			val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
		}
	
		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var doc, docElem, rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			doc = elem.ownerDocument;
			docElem = doc.documentElement;
			win = doc.defaultView;
	
			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( jQuery.isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// THIS FILE IS GENERATED - DO NOT EDIT!
	/*!mobile-detect v1.3.6 2017-04-05*/
	/*global module:false, define:false*/
	/*jshint latedef:false*/
	/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
	(function (define, undefined) {
	define(function () {
	    'use strict';
	
	    var impl = {};
	
	    impl.mobileDetectRules = {
	    "phones": {
	        "iPhone": "\\biPhone\\b|\\biPod\\b",
	        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
	        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m",
	        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
	        "Dell": "Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue Pro|Dell Flash|Dell Smoke|Dell Mini 3iX|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
	        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b",
	        "Samsung": "\\bSamsung\\b|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C",
	        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323)",
	        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
	        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
	        "NokiaLumia": "Lumia [0-9]{3,4}",
	        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
	        "Palm": "PalmSource|Palm",
	        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
	        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
	        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
	        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
	        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
	        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
	        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
	        "Alcatel": "Alcatel",
	        "Nintendo": "Nintendo 3DS",
	        "Amoi": "Amoi",
	        "INQ": "INQ",
	        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
	    },
	    "tablets": {
	        "iPad": "iPad|iPad.*Mobile",
	        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
	        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587",
	        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
	        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
	        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
	        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z",
	        "BlackBerryTablet": "PlayBook|RIM Tablet",
	        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
	        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
	        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
	        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
	        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
	        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
	        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
	        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
	        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)",
	        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
	        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
	        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
	        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
	        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
	        "IRUTablet": "M702pro",
	        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
	        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
	        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
	        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
	        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
	        "NokiaLumiaTablet": "Lumia 2520",
	        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
	        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
	        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
	        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
	        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
	        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
	        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
	        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
	        "FlyTablet": "IQ310|Fly Vision",
	        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris [E|M]10)|Maxwell.*Lite|Maxwell.*Plus",
	        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim",
	        "NecTablet": "\\bN-06D|\\bN-08D",
	        "PantechTablet": "Pantech.*P4100",
	        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
	        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
	        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
	        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
	        "NabiTablet": "Android.*\\bNabi",
	        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
	        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
	        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
	        "PlaystationTablet": "Playstation.*(Portable|Vita)",
	        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
	        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
	        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
	        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
	        "GalapadTablet": "Android.*\\bG1\\b",
	        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
	        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
	        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
	        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
	        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
	        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
	        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
	        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
	        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)",
	        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
	        "DPSTablet": "DPS Dream 9|DPS Dual 7",
	        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
	        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
	        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
	        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
	        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
	        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
	        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
	        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
	        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
	        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
	        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
	        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
	        "iMobileTablet": "i-mobile i-note",
	        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
	        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
	        "AMPETablet": "Android.* A78 ",
	        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
	        "TecnoTablet": "TECNO P9",
	        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
	        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
	        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
	        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
	        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
	        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
	        "CaptivaTablet": "CAPTIVA PAD",
	        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
	        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
	        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
	        "JaytechTablet": "TPC-PA762",
	        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
	        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
	        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
	        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
	        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
	        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
	        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
	        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
	        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
	        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
	        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
	        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
	        "UbislateTablet": "UbiSlate[\\s]?7C",
	        "PocketBookTablet": "Pocketbook",
	        "KocasoTablet": "\\b(TB-1207)\\b",
	        "HisenseTablet": "\\b(F5281|E2371)\\b",
	        "Hudl": "Hudl HT7S3|Hudl 2",
	        "TelstraTablet": "T-Hub2",
	        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b"
	    },
	    "oss": {
	        "AndroidOS": "Android",
	        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
	        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
	        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
	        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
	        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
	        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad",
	        "MeeGoOS": "MeeGo",
	        "MaemoOS": "Maemo",
	        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
	        "webOS": "webOS|hpwOS",
	        "badaOS": "\\bBada\\b",
	        "BREWOS": "BREW"
	    },
	    "uas": {
	        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
	        "Dolfin": "\\bDolfin\\b",
	        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
	        "Skyfire": "Skyfire",
	        "Edge": "Mobile Safari\/[.0-9]* Edge",
	        "IE": "IEMobile|MSIEMobile",
	        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
	        "Bolt": "bolt",
	        "TeaShark": "teashark",
	        "Blazer": "Blazer",
	        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
	        "UCBrowser": "UC.*Browser|UCWEB",
	        "baiduboxapp": "baiduboxapp",
	        "baidubrowser": "baidubrowser",
	        "DiigoBrowser": "DiigoBrowser",
	        "Puffin": "Puffin",
	        "Mercury": "\\bMercury\\b",
	        "ObigoBrowser": "Obigo",
	        "NetFront": "NF-Browser",
	        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
	        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
	    },
	    "props": {
	        "Mobile": "Mobile\/[VER]",
	        "Build": "Build\/[VER]",
	        "Version": "Version\/[VER]",
	        "VendorID": "VendorID\/[VER]",
	        "iPad": "iPad.*CPU[a-z ]+[VER]",
	        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
	        "iPod": "iPod.*CPU[a-z ]+[VER]",
	        "Kindle": "Kindle\/[VER]",
	        "Chrome": [
	            "Chrome\/[VER]",
	            "CriOS\/[VER]",
	            "CrMo\/[VER]"
	        ],
	        "Coast": [
	            "Coast\/[VER]"
	        ],
	        "Dolfin": "Dolfin\/[VER]",
	        "Firefox": [
	            "Firefox\/[VER]",
	            "FxiOS\/[VER]"
	        ],
	        "Fennec": "Fennec\/[VER]",
	        "Edge": "Edge\/[VER]",
	        "IE": [
	            "IEMobile\/[VER];",
	            "IEMobile [VER]",
	            "MSIE [VER];",
	            "Trident\/[0-9.]+;.*rv:[VER]"
	        ],
	        "NetFront": "NetFront\/[VER]",
	        "NokiaBrowser": "NokiaBrowser\/[VER]",
	        "Opera": [
	            " OPR\/[VER]",
	            "Opera Mini\/[VER]",
	            "Version\/[VER]"
	        ],
	        "Opera Mini": "Opera Mini\/[VER]",
	        "Opera Mobi": "Version\/[VER]",
	        "UC Browser": "UC Browser[VER]",
	        "MQQBrowser": "MQQBrowser\/[VER]",
	        "MicroMessenger": "MicroMessenger\/[VER]",
	        "baiduboxapp": "baiduboxapp\/[VER]",
	        "baidubrowser": "baidubrowser\/[VER]",
	        "SamsungBrowser": "SamsungBrowser\/[VER]",
	        "Iron": "Iron\/[VER]",
	        "Safari": [
	            "Version\/[VER]",
	            "Safari\/[VER]"
	        ],
	        "Skyfire": "Skyfire\/[VER]",
	        "Tizen": "Tizen\/[VER]",
	        "Webkit": "webkit[ \/][VER]",
	        "PaleMoon": "PaleMoon\/[VER]",
	        "Gecko": "Gecko\/[VER]",
	        "Trident": "Trident\/[VER]",
	        "Presto": "Presto\/[VER]",
	        "Goanna": "Goanna\/[VER]",
	        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
	        "Android": "Android [VER]",
	        "BlackBerry": [
	            "BlackBerry[\\w]+\/[VER]",
	            "BlackBerry.*Version\/[VER]",
	            "Version\/[VER]"
	        ],
	        "BREW": "BREW [VER]",
	        "Java": "Java\/[VER]",
	        "Windows Phone OS": [
	            "Windows Phone OS [VER]",
	            "Windows Phone [VER]"
	        ],
	        "Windows Phone": "Windows Phone [VER]",
	        "Windows CE": "Windows CE\/[VER]",
	        "Windows NT": "Windows NT [VER]",
	        "Symbian": [
	            "SymbianOS\/[VER]",
	            "Symbian\/[VER]"
	        ],
	        "webOS": [
	            "webOS\/[VER]",
	            "hpwOS\/[VER];"
	        ]
	    },
	    "utils": {
	        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
	        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
	        "DesktopMode": "WPDesktop",
	        "TV": "SonyDTV|HbbTV",
	        "WebKit": "(webkit)[ \/]([\\w.]+)",
	        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|PLAYSTATION|Xbox)\\b",
	        "Watch": "SM-V700"
	    }
	};
	
	    // following patterns come from http://detectmobilebrowsers.com/
	    impl.detectMobileBrowsers = {
	        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        tabletPattern: /android|ipad|playbook|silk/i
	    };
	
	    var hasOwnProp = Object.prototype.hasOwnProperty,
	        isArray;
	
	    impl.FALLBACK_PHONE = 'UnknownPhone';
	    impl.FALLBACK_TABLET = 'UnknownTablet';
	    impl.FALLBACK_MOBILE = 'UnknownMobile';
	
	    isArray = ('isArray' in Array) ?
	        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };
	
	    function equalIC(a, b) {
	        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
	    }
	
	    function containsIC(array, value) {
	        var valueLC, i, len = array.length;
	        if (!len || !value) {
	            return false;
	        }
	        valueLC = value.toLowerCase();
	        for (i = 0; i < len; ++i) {
	            if (valueLC === array[i].toLowerCase()) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function convertPropsToRegExp(object) {
	        for (var key in object) {
	            if (hasOwnProp.call(object, key)) {
	                object[key] = new RegExp(object[key], 'i');
	            }
	        }
	    }
	
	    (function init() {
	        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
	        for (key in mobileDetectRules.props) {
	            if (hasOwnProp.call(mobileDetectRules.props, key)) {
	                values = mobileDetectRules.props[key];
	                if (!isArray(values)) {
	                    values = [values];
	                }
	                len = values.length;
	                for (i = 0; i < len; ++i) {
	                    value = values[i];
	                    verPos = value.indexOf('[VER]');
	                    if (verPos >= 0) {
	                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
	                    }
	                    values[i] = new RegExp(value, 'i');
	                }
	                mobileDetectRules.props[key] = values;
	            }
	        }
	        convertPropsToRegExp(mobileDetectRules.oss);
	        convertPropsToRegExp(mobileDetectRules.phones);
	        convertPropsToRegExp(mobileDetectRules.tablets);
	        convertPropsToRegExp(mobileDetectRules.uas);
	        convertPropsToRegExp(mobileDetectRules.utils);
	
	        // copy some patterns to oss0 which are tested first (see issue#15)
	        mobileDetectRules.oss0 = {
	            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
	            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
	        };
	    }());
	
	    /**
	     * Test userAgent string against a set of rules and find the first matched key.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
	     * @private
	     */
	    impl.findMatch = function(rules, userAgent) {
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    return key;
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Test userAgent string against a set of rules and return an array of matched keys.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
	     * @private
	     */
	    impl.findMatches = function(rules, userAgent) {
	        var result = [];
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    result.push(key);
	                }
	            }
	        }
	        return result;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {String} version or <tt>null</tt> if version not found
	     * @private
	     */
	    impl.getVersionStr = function (propertyName, userAgent) {
	        var props = impl.mobileDetectRules.props, patterns, i, len, match;
	        if (hasOwnProp.call(props, propertyName)) {
	            patterns = props[propertyName];
	            len = patterns.length;
	            for (i = 0; i < len; ++i) {
	                match = patterns[i].exec(userAgent);
	                if (match !== null) {
	                    return match[1];
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {Number} version or <tt>NaN</tt> if version not found
	     * @private
	     */
	    impl.getVersion = function (propertyName, userAgent) {
	        var version = impl.getVersionStr(propertyName, userAgent);
	        return version ? impl.prepareVersionNo(version) : NaN;
	    };
	
	    /**
	     * Prepare the version number.
	     *
	     * @param {String} version
	     * @return {Number} the version number as a floating number
	     * @private
	     */
	    impl.prepareVersionNo = function (version) {
	        var numbers;
	
	        numbers = version.split(/[a-z._ \/\-]/i);
	        if (numbers.length === 1) {
	            version = numbers[0];
	        }
	        if (numbers.length > 1) {
	            version = numbers[0] + '.';
	            numbers.shift();
	            version += numbers.join('');
	        }
	        return Number(version);
	    };
	
	    impl.isMobileFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
	            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
	    };
	
	    impl.isTabletFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
	    };
	
	    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
	        if (cache.mobile !== undefined) {
	            return;
	        }
	        var phone, tablet, phoneSized;
	
	        // first check for stronger tablet rules, then phone (see issue#5)
	        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
	        if (tablet) {
	            cache.mobile = cache.tablet = tablet;
	            cache.phone = null;
	            return; // unambiguously identified as tablet
	        }
	
	        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
	        if (phone) {
	            cache.mobile = cache.phone = phone;
	            cache.tablet = null;
	            return; // unambiguously identified as phone
	        }
	
	        // our rules haven't found a match -> try more general fallback rules
	        if (impl.isMobileFallback(userAgent)) {
	            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
	            if (phoneSized === undefined) {
	                cache.mobile = impl.FALLBACK_MOBILE;
	                cache.tablet = cache.phone = null;
	            } else if (phoneSized) {
	                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
	                cache.tablet = null;
	            } else {
	                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	                cache.phone = null;
	            }
	        } else if (impl.isTabletFallback(userAgent)) {
	            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	            cache.phone = null;
	        } else {
	            // not mobile at all!
	            cache.mobile = cache.tablet = cache.phone = null;
	        }
	    };
	
	    // t is a reference to a MobileDetect instance
	    impl.mobileGrade = function (t) {
	        // impl note:
	        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
	        // When changes are made in Mobile_Detect.php, copy this method and replace:
	        //     $this-> / t.
	        //     self::MOBILE_GRADE_(.) / '$1'
	        //     , self::VERSION_TYPE_FLOAT / (nothing)
	        //     isIOS() / os('iOS')
	        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
	        var $isMobile = t.mobile() !== null;
	
	        if (
	            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
	            t.os('iOS') && t.version('iPad')>=4.3 ||
	            t.os('iOS') && t.version('iPhone')>=3.1 ||
	            t.os('iOS') && t.version('iPod')>=3.1 ||
	
	            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
	            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
	            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
	            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
	            ( t.version('Android')>2.1 && t.is('Webkit') ) ||
	
	            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
	            t.version('Windows Phone OS')>=7.0 ||
	
	            // Blackberry 7 - Tested on BlackBerry Torch 9810
	            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
	            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
	            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
	            t.match('Playbook.*Tablet') ||
	
	            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
	            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
	            // Palm WebOS 3.0  - Tested on HP TouchPad
	            t.match('hp.*TouchPad') ||
	
	            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
	            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||
	
	            // Chrome for Android - Tested on Android 4.0, 4.1 device
	            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||
	
	            // Skyfire 4.1 - Tested on Android 2.3 device
	            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||
	
	            // Opera Mobile 11.5-12: Tested on Android 2.3
	            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||
	
	            // Meego 1.2 - Tested on Nokia 950 and N9
	            t.is('MeeGoOS') ||
	
	            // Tizen (pre-release) - Tested on early hardware
	            t.is('Tizen') ||
	
	            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
	            // @todo: more tests here!
	            t.is('Dolfin') && t.version('Bada')>=2.0 ||
	
	            // UC Browser - Tested on Android 2.3 device
	            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||
	
	            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
	            ( t.match('Kindle Fire') ||
	                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||
	
	            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
	            t.is('AndroidOS') && t.is('NookTablet') ||
	
	            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
	            t.version('Chrome')>=11 && !$isMobile ||
	
	            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
	            t.version('Safari')>=5.0 && !$isMobile ||
	
	            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
	            t.version('Firefox')>=4.0 && !$isMobile ||
	
	            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
	            t.version('MSIE')>=7.0 && !$isMobile ||
	
	            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
	            // @reference: http://my.opera.com/community/openweb/idopera/
	            t.version('Opera')>=10 && !$isMobile
	
	            ){
	            return 'A';
	        }
	
	        if (
	            t.os('iOS') && t.version('iPad')<4.3 ||
	            t.os('iOS') && t.version('iPhone')<3.1 ||
	            t.os('iOS') && t.version('iPod')<3.1 ||
	
	            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
	            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||
	
	            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
	            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
	                (t.version('Android')>=2.3 || t.is('iOS')) ) ||
	
	            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
	            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||
	
	            // @todo: report this (tested on Nokia N71)
	            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
	            ){
	            return 'B';
	        }
	
	        if (
	        // Blackberry 4.x - Tested on the Curve 8330
	            t.version('BlackBerry')<5.0 ||
	            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
	            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2
	
	            ){
	            return 'C';
	        }
	
	        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
	        //will receive the basic, C grade experience.
	        return 'C';
	    };
	
	    impl.detectOS = function (ua) {
	        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
	            impl.findMatch(impl.mobileDetectRules.oss, ua);
	    };
	
	    impl.getDeviceSmallerSide = function () {
	        return window.screen.width < window.screen.height ?
	            window.screen.width :
	            window.screen.height;
	    };
	
	    /**
	     * Constructor for MobileDetect object.
	     * <br>
	     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
	     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
	     *     <strong>Find information how to download and install:</strong>
	     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
	     * </div>
	     *
	     * @example <pre>
	     *     var md = new MobileDetect(window.navigator.userAgent);
	     *     if (md.mobile()) {
	     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
	     *     }
	     * </pre>
	     *
	     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
	     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
	     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
	     *        as phone.
	     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
	     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
	     *        for Android</a>.<br>
	     *        If you provide a value < 0, then this "fuzzy" check is disabled.
	     * @constructor
	     * @global
	     */
	    function MobileDetect(userAgent, maxPhoneWidth) {
	        this.ua = userAgent || '';
	        this._cache = {};
	        //600dp is typical 7" tablet minimum width
	        this.maxPhoneWidth = maxPhoneWidth || 600;
	    }
	
	    MobileDetect.prototype = {
	        constructor: MobileDetect,
	
	        /**
	         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
	         * <br>
	         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
	         * <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
	         * @function MobileDetect#mobile
	         */
	        mobile: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.mobile;
	        },
	
	        /**
	         * Returns the detected phone type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
	         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
	         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
	         * @function MobileDetect#phone
	         */
	        phone: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.phone;
	        },
	
	        /**
	         * Returns the detected tablet type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPad, NexusTablet, SamsungTablet, Kindle, SurfaceTablet, HPTablet, AsusTablet,
	         * BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet, AcerTablet,
	         * ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet, LenovoTablet,
	         * DellTablet, YarvikTablet, MedionTablet, ArnovaTablet, IntensoTablet, IRUTablet,
	         * MegafonTablet, EbodaTablet, AllViewTablet, ArchosTablet, AinolTablet,
	         * NokiaLumiaTablet, SonyTablet, PhilipsTablet, CubeTablet, CobyTablet, MIDTablet,
	         * MSITablet, SMiTTablet, RockChipTablet, FlyTablet, bqTablet, HuaweiTablet,
	         * NecTablet, PantechTablet, BronchoTablet, VersusTablet, ZyncTablet,
	         * PositivoTablet, NabiTablet, KoboTablet, DanewTablet, TexetTablet,
	         * PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
	         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
	         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
	         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
	         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
	         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
	         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
	         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
	         * OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet, OndaTablet,
	         * JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet, LavaTablet,
	         * AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MiTablet, NibiruTablet,
	         * NexoTablet, LeaderTablet, UbislateTablet, PocketBookTablet, KocasoTablet,
	         * HisenseTablet, Hudl, TelstraTablet, GenericTablet</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
	         * @function MobileDetect#tablet
	         */
	        tablet: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.tablet;
	        },
	
	        /**
	         * Returns the (first) detected user-agent string or <tt>null</tt>.
	         * <br>
	         * The returned user-agent is one of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {String} the key for the detected user-agent or <tt>null</tt>
	         * @function MobileDetect#userAgent
	         */
	        userAgent: function () {
	            if (this._cache.userAgent === undefined) {
	                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgent;
	        },
	
	        /**
	         * Returns all detected user-agent strings.
	         * <br>
	         * The array is empty or contains one or more of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
	         * @function MobileDetect#userAgents
	         */
	        userAgents: function () {
	            if (this._cache.userAgents === undefined) {
	                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgents;
	        },
	
	        /**
	         * Returns the detected operating system string or <tt>null</tt>.
	         * <br>
	         * The operating system is one of following keys:<br>
	         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
	         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
	         *
	         * @returns {String} the key for the detected operating system.
	         * @function MobileDetect#os
	         */
	        os: function () {
	            if (this._cache.os === undefined) {
	                this._cache.os = impl.detectOS(this.ua);
	            }
	            return this._cache.os;
	        },
	
	        /**
	         * Get the version (as Number) of the given property in the User-Agent.
	         * <br>
	         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
	         *          Be careful when comparing this value with '==' operator!
	         * @function MobileDetect#version
	         */
	        version: function (key) {
	            return impl.getVersion(key, this.ua);
	        },
	
	        /**
	         * Get the version (as String) of the given property in the User-Agent.
	         * <br>
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
	         *
	         * @function MobileDetect#versionStr
	         */
	        versionStr: function (key) {
	            return impl.getVersionStr(key, this.ua);
	        },
	
	        /**
	         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
	         *
	         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
	         *        tablet family.<br>
	         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
	         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
	         *        Additionally you have following keys:<br>
	         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
	         *
	         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
	         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
	         * @function MobileDetect#is
	         */
	        is: function (key) {
	            return containsIC(this.userAgents(), key) ||
	                   equalIC(key, this.os()) ||
	                   equalIC(key, this.phone()) ||
	                   equalIC(key, this.tablet()) ||
	                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
	        },
	
	        /**
	         * Do a quick test against navigator::userAgent.
	         *
	         * @param {String|RegExp} pattern the pattern, either as String or RegExp
	         *                        (a string will be converted to a case-insensitive RegExp).
	         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
	         * @function MobileDetect#match
	         */
	        match: function (pattern) {
	            if (!(pattern instanceof RegExp)) {
	                pattern = new RegExp(pattern, 'i');
	            }
	            return pattern.test(this.ua);
	        },
	
	        /**
	         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
	         * <br>
	         * Obviously this method makes sense in browser environments only (not for Node.js)!
	         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
	         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
	         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
	         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
	         *          Will always return <code>undefined</code> server-side.
	         */
	        isPhoneSized: function (maxPhoneWidth) {
	            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
	        },
	
	        /**
	         * Returns the mobile grade ('A', 'B', 'C').
	         *
	         * @returns {String} one of the mobile grades ('A', 'B', 'C').
	         * @function MobileDetect#mobileGrade
	         */
	        mobileGrade: function () {
	            if (this._cache.grade === undefined) {
	                this._cache.grade = impl.mobileGrade(this);
	            }
	            return this._cache.grade;
	        }
	    };
	
	    // environment-dependent
	    if (typeof window !== 'undefined' && window.screen) {
	        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
	            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
	        };
	    } else {
	        MobileDetect.isPhoneSized = function () {};
	    }
	
	    // should not be replaced by a completely new object - just overwrite existing methods
	    MobileDetect._impl = impl;
	    
	    MobileDetect.version = '1.3.6 2017-04-05';
	
	    return MobileDetect;
	}); // end of call of define()
	})((function (undefined) {
	    if (typeof module !== 'undefined' && module.exports) {
	        return function (factory) { module.exports = factory(); };
	    } else if (true) {
	        return __webpack_require__(129);
	    } else if (typeof window !== 'undefined') {
	        return function (factory) { window.MobileDetect = factory(); };
	    } else {
	        // please file a bug if you get this error!
	        throw new Error('unknown environment');
	    }
	})());

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAA0CAMAAAA+P9EyAAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMA4OT3rwPb0vryzKTpx4mFF9bOyMG5tKpPcmo675xdEguXlZJXvo13ZEpAIBwGgDItLyndiWf1AAABsklEQVRIx43U6U7rMBAF4HiJnX3f97Z0hQL3zvu/G3JUiCB17PMnivTpWE40Y/w39GKHk5bDwFsdhwAgnPQcsFbPAQSTngPU6jnmhZOOA3zMW7VDJStqtB+VfR4P3qmFP1QuTYtzg6CoJpn7TuYECcHM/dh0DvGK4ISszj8142YfRnndYP+wb8LblgPnfLmmwUsQxnY/yh1Ffl0fTtVQH4+230od8w/ljofDe8Nitnf6UeKAQ8EzJwyBY9cFwNXafceCpCw9giiIuJHMQZrmWQdAYA6uTIkDKGkHS2gkc0n869WrzOfOApFVJQJl7BdzduoUr3oO/dNy57vyXNrnyaf6Hsi9fN6NLUeQaNsFb8t3lkAOrnu5GwpnQQPDq/ET54lBXewRsruaxhIOT+LQg7sXZUviZ/838a/tXLYEpas2P2V9ZPxJjFcur2+m8Tc5EOCAu8ehHtiwe5PMOStp9qglQAZTvp99LJ7Cuo+ylUPcssG2hOuzoDLlew0XMXLs+QbR5p5kLOEZAmswFXvXQdhLaKSzx4kYFpXL5uFTOy6uqXalKFO5eYzVIXQ0dHIztdgXgCWfz/kKyAUAAAAASUVORK5CYII="

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(32)
	
	/* template */
	var __vue_template__ = __webpack_require__(123)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(34)
	
	/* template */
	var __vue_template__ = __webpack_require__(116)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(35)
	
	/* template */
	var __vue_template__ = __webpack_require__(115)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(36)
	
	/* template */
	var __vue_template__ = __webpack_require__(125)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(37)
	
	/* template */
	var __vue_template__ = __webpack_require__(117)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(38)
	
	/* template */
	var __vue_template__ = __webpack_require__(120)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(39)
	
	/* template */
	var __vue_template__ = __webpack_require__(113)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(40)
	
	/* template */
	var __vue_template__ = __webpack_require__(119)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(41)
	
	/* template */
	var __vue_template__ = __webpack_require__(112)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(42)
	
	/* template */
	var __vue_template__ = __webpack_require__(118)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(44)
	
	/* template */
	var __vue_template__ = __webpack_require__(124)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(45)
	
	/* template */
	var __vue_template__ = __webpack_require__(121)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overview"
	  }, [(_vm.$mobile && _vm.questionToggle != null) ? _c('aside', {
	    staticClass: "questionToggle",
	    class: {
	      'toggled': _vm.questionToggle
	    },
	    on: {
	      "click": _vm.toggleQuestion
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    on: {
	      "enter": _vm.slideinQuestion,
	      "leave": _vm.slideoutQuestion
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.$mobile && _vm.questionToggle === true || _vm.questionToggle != false),
	      expression: "$mobile && questionToggle === true || questionToggle != false"
	    }],
	    staticClass: "introtext-container",
	    class: {
	      'floating': _vm.$mobile && _vm.questionToggle != null, 'mobile': _vm.$mobile
	    }
	  }, [_c('div', {
	    staticClass: "introtext",
	    domProps: {
	      "innerHTML": _vm._s(_vm.episode.introtext)
	    },
	    on: {
	      "click": _vm.setupQuestionToggle
	    }
	  })])]), _vm._v(" "), (!_vm.$mobile) ? _c('Answers', {
	    attrs: {
	      "type": 'inline',
	      "popup": true,
	      "mod": _vm.mod
	    }
	  }) : _c('AnswersSlideshow', {
	    attrs: {
	      "mod": _vm.mod
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "footer",
	    class: {
	      'mobile': _vm.$mobile
	    }
	  }, [_c('div', {
	    staticClass: "footer-content"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.pointResponse))]), _c('br'), _vm._v("\n            Je hebt met deze vraag in totaal " + _vm._s(_vm.episode.points) + " punten verdiend!\n            "), _c('a', {
	    staticClass: "button black right",
	    class: {
	      'mobile': _vm.$mobile
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.proceed($event)
	      }
	    }
	  }, [_vm._v("OK")]), _vm._v(" "), _c('div', {
	    staticClass: "points-container"
	  }, [_c('div', {
	    staticClass: "points"
	  }, [_c('span', {
	    staticClass: "count"
	  }, [_vm._v(_vm._s(_vm.points))])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "intro"
	  }, [_c('splash', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.splash),
	      expression: "splash"
	    }],
	    nativeOn: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.startAnimation($event)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.splash),
	      expression: "!splash"
	    }],
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "video-container"
	  }, [_c('video', {
	    staticStyle: {
	      "background": "black"
	    },
	    attrs: {
	      "id": "video",
	      "autoplay": "",
	      "controls": "true",
	      "width": "100%",
	      "height": "100%",
	      "src": _vm.episode.animation[_vm.key].file,
	      "type": "video/mp4"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "intro-animation-text"
	  }, [_vm._v(" " + _vm._s(_vm.episode.animation[_vm.key].text) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "intro-animation-image-container"
	  }, [_c('div', {
	    staticClass: "intro-animation-container"
	  }, [_c('div', {
	    staticClass: "back-anim-container"
	  }, [_c('img', {
	    staticClass: "intro-animation-image intro-animation-image-back",
	    attrs: {
	      "src": _vm.episode.animation[_vm.key].file
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "front-anim-container"
	  }, [_c('img', {
	    staticClass: "intro-animation-image intro-animation-image-front",
	    attrs: {
	      "src": _vm.episode.animation[_vm.prevKey].file
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "intro-animation-text"
	  }, [_vm._v(" " + _vm._s(_vm.episode.animation[_vm.key].text) + " ")])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "answers",
	    class: _vm.type,
	    attrs: {
	      "data-popup": _vm.popup
	    }
	  }, [_c('transition-group', {
	    staticClass: "answer-cards",
	    attrs: {
	      "id": "answer-cards",
	      "name": "staggered-fade",
	      "tag": "ul",
	      "css": false
	    },
	    on: {
	      "before-enter": _vm.beforeEnter,
	      "enter": _vm.enter,
	      "leave": _vm.leave
	    }
	  }, _vm._l((_vm.answers), function(answer, index) {
	    return _c('li', {
	      key: index,
	      staticClass: "answer-card",
	      class: {
	        'correct': answer.points
	      },
	      style: ({
	        width: _vm.width()
	      }),
	      on: {
	        "click": function($event) {
	          _vm.expand(index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "points"
	    }, [_c('span', [_vm._v(_vm._s(answer.points))]), _vm._v(" punten")]), _vm._v(" "), _c('div', {
	      staticClass: "ac-question"
	    }, [_vm._v(_vm._s(answer.question))]), _vm._v(" "), _c('div', {
	      staticClass: "answer"
	    }, [_vm._v("Jij zei: "), _c('span', [_vm._v(_vm._s(answer.answer))])])])
	  }))], 1)
	},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "carousel"
	  }, [_c('ul', {
	    staticClass: "container",
	    style: ({
	      left: '-' + _vm.x,
	      width: _vm.answers.length * 100 + 'vw'
	    }),
	    on: {
	      "click": _vm.closeCarousel
	    }
	  }, [_vm._l((_vm.answers), function(answer, index) {
	    return _c('li', [_c('div', {
	      staticClass: "card",
	      class: {
	        'correct': answer.points
	      }
	    }, [_c('span', {
	      staticClass: "close",
	      on: {
	        "click": function($event) {
	          _vm.$store.dispatch('HIDE_CAROUSEL')
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "action"
	    }, [_c('span', [_vm._v("actie " + _vm._s(index + 1) + " / " + _vm._s(_vm.answers.length))])]), _vm._v(" "), _c('div', {
	      staticClass: "ac-question"
	    }, [_vm._v(_vm._s(answer.question))]), _vm._v(" "), _c('div', {
	      staticClass: "answer"
	    }, [_vm._v("Jij zei: "), _c('span', [_vm._v(_vm._s(answer.answer))]), _c('span', {
	      staticClass: "points"
	    }, [_c('span', [_vm._v(_vm._s(answer.points))]), _vm._v(" punten")])])])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrows"
	  }, [_c('span', {
	    staticClass: "arrow arrow-left",
	    class: {
	      'hidden': _vm.$store.state.carousel.active == 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.$store.dispatch('PREVIOUS_CAROUSEL_ITEM')
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "arrow arrow-right",
	    class: {
	      'hidden': _vm.$store.state.carousel.active == this.answers.length - 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.$store.dispatch('NEXT_CAROUSEL_ITEM')
	      }
	    }
	  })])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-touch', {
	    staticClass: "answers answersslideshow",
	    attrs: {
	      "tag": "div"
	    },
	    on: {
	      "swipeleft": function($event) {
	        (_vm.current < _vm.answers.length - 1) ? _vm.current++ : _vm.current = _vm.current
	      },
	      "swiperight": function($event) {
	        (_vm.current > 0) ? _vm.current-- : _vm.current = _vm.current
	      }
	    }
	  }, [_c('transition-group', {
	    staticClass: "answer-cards",
	    attrs: {
	      "id": "answer-cards",
	      "name": "staggered-fade",
	      "tag": "ul",
	      "css": false,
	      "mode": "in-out"
	    },
	    on: {
	      "enter": _vm.enter,
	      "leave": _vm.leave
	    }
	  }, _vm._l((_vm.answers), function(answer, index) {
	    return (_vm.current === index) ? _c('li', {
	      key: index,
	      staticClass: "answer-card",
	      class: {
	        'correct': answer.points
	      }
	    }, [_c('div', {
	      staticClass: "ac-question"
	    }, [_vm._v(_vm._s(answer.question))]), _vm._v(" "), _c('div', {
	      staticClass: "answer"
	    }, [_vm._v("Jij zei: "), _c('span', [_vm._v(_vm._s(answer.answer))]), _c('span', {
	      staticClass: "points"
	    }, [_vm._v(_vm._s(answer.points) + " punten")])])]) : _vm._e()
	  })), _vm._v(" "), _c('span', {
	    staticClass: "slideshow-button prev",
	    on: {
	      "click": function($event) {
	        (_vm.current > 0) ? _vm.current-- : _vm.current = _vm.current
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "slideshow-button next",
	    on: {
	      "click": function($event) {
	        (_vm.current < _vm.answers.length - 1) ? _vm.current++ : _vm.current = _vm.current
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "game"
	  }, [_vm._v("\n    Game"), _c('br'), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Go back home")]), _vm._v(" (or use the browser button)"), _c('br'), _c('br')], 1)
	},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "question"
	  }, [(_vm.$mobile && _vm.questionToggle != null) ? _c('aside', {
	    staticClass: "questionToggle",
	    class: {
	      'toggled': _vm.questionToggle
	    },
	    on: {
	      "click": _vm.toggleQuestion
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    on: {
	      "enter": _vm.slideinQuestion,
	      "leave": _vm.slideoutQuestion
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.$mobile && _vm.questionToggle === true || _vm.questionToggle != false),
	      expression: "$mobile && questionToggle === true || questionToggle != false"
	    }],
	    staticClass: "introtext-container",
	    class: {
	      'floating': _vm.$mobile && _vm.questionToggle != null, 'mobile': _vm.$mobile
	    }
	  }, [_c('div', {
	    staticClass: "introtext",
	    domProps: {
	      "innerHTML": _vm._s(_vm.episode.introtext)
	    },
	    on: {
	      "click": _vm.setupQuestionToggle
	    }
	  })])]), _vm._v(" "), (!_vm.$mobile) ? _c('Answers', {
	    attrs: {
	      "type": 'compact',
	      "mod": 0
	    }
	  }) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fadein"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.$mobile && _vm.questionToggle != null || !_vm.$mobile),
	      expression: "$mobile && questionToggle != null || !$mobile"
	    }],
	    staticClass: "question-container",
	    class: {
	      'inline': _vm.showFeedback, 'mobile': _vm.$mobile
	    }
	  }, [(_vm.action) ? _c('div', {
	    staticClass: "question-box"
	  }, [_c('div', {
	    staticClass: "question-action-header"
	  }, [_vm._v("\n                    actie " + _vm._s(_vm.action.id + 1) + " / " + _vm._s(_vm.total) + "\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "question-action-title"
	  }, [_vm._v("\n                    " + _vm._s(_vm.action.title) + "\n                ")]), _vm._v(" "), _c('div', {
	    staticClass: "question-action-answers"
	  }, [_c('div', {
	    staticClass: "answer answer-left",
	    class: {
	      'active': _vm.answer === false
	    },
	    on: {
	      "click": function($event) {
	        _vm.processAction(false)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.config.false))]), _vm._v(" "), _c('div', {
	    staticClass: "answer answer-right",
	    class: {
	      'active': _vm.answer
	    },
	    on: {
	      "click": function($event) {
	        _vm.processAction(true)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.config.true))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showFeedback),
	      expression: "showFeedback"
	    }],
	    staticClass: "feedback-container",
	    class: {
	      'correct': _vm.correct, 'mobile': _vm.$mobile
	    }
	  }, [(_vm.action) ? _c('div', {
	    staticClass: "feedback"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("\n                " + _vm._s((_vm.correct) ? 'Goede' : 'Verkeerde') + " beslissing!\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "feedback-text"
	  }, [_vm._v("\n                " + _vm._s(_vm.action.feedback) + "\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [(!_vm.$mobile) ? _c('span', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "button",
	    on: {
	      "click": _vm.nextAction
	    }
	  }, [_vm._v(" OK")]), _vm._v(" "), _c('br'), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.$mobile || _vm.$mobile && _vm.questionToggle != null),
	      expression: "!$mobile || $mobile && questionToggle != null"
	    }],
	    staticClass: "points-container",
	    class: {
	      'mobile': _vm.$mobile
	    }
	  }, [_vm._m(0), _vm._v("\n        " + _vm._s(_vm.points)), _c('span', [_vm._v(" punten")])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "explosion-container"
	  }, [_c('div', {
	    staticClass: "anim-container"
	  }, [_c('div', {
	    staticClass: "glow"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bolts"
	  }, [_c('img', {
	    staticClass: "bolt bolt1",
	    attrs: {
	      "src": __webpack_require__(5)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "bolt bolt2",
	    attrs: {
	      "src": __webpack_require__(5)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "bolt bolt3",
	    attrs: {
	      "src": __webpack_require__(5)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "bolt bolt4",
	    attrs: {
	      "src": __webpack_require__(5)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "bolt bolt5",
	    attrs: {
	      "src": __webpack_require__(5)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "halos"
	  }, [_c('img', {
	    staticClass: "halo halo1",
	    attrs: {
	      "src": __webpack_require__(15)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "halo halo2",
	    attrs: {
	      "src": __webpack_require__(15)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "halo halo3",
	    attrs: {
	      "src": __webpack_require__(15)
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "bricks"
	  }, [_c('img', {
	    staticClass: "brick brick1",
	    attrs: {
	      "src": __webpack_require__(94)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "brick brick2",
	    attrs: {
	      "src": __webpack_require__(93)
	    }
	  })])])])
	}]}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "intro-image"
	  }, [_c('div', {
	    staticClass: "img-container"
	  }, [_c('div', {
	    staticClass: "animation-container"
	  }, [_c('img', {
	    staticClass: "image-intro",
	    attrs: {
	      "src": _vm.episode.introImage,
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "link",
	    on: {
	      "click": function($event) {
	        _vm.playClick()
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "intro-text-container"
	  }, [_c('div', {
	    staticClass: "intro-text-box"
	  }, [_c('div', {
	    staticClass: "introtext title-02",
	    domProps: {
	      "innerHTML": _vm._s(_vm.episode.introImageText)
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info-screen"
	  }, [_c('div', {
	    staticClass: "intro-text-container"
	  }, [_c('div', {
	    staticClass: "intro-text-box"
	  }, [_c('div', {
	    staticClass: "introtext title-02",
	    domProps: {
	      "innerHTML": _vm._s(_vm.episode.introtext)
	    }
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "to": "/vraag"
	    }
	  }, [_vm._v("OK")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "verdict",
	    class: {
	      'mobile': _vm.$mobile
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "intro-text-container"
	  }, [_c('div', {
	    staticClass: "intro-text-box"
	  }, [_c('div', {
	    staticClass: "introtext title-02"
	  }, [_vm._v("\n                De rechter volgde de eis van de officier van justitie en legde de man 8 jaar gevangenisstraf op en tbs met dwangverpleging. In hoger beroep werd de man veroordeeld tot 6 jaar gevangenisstraf met tbs.\n            ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "button",
	    class: {
	      'mobile': _vm.$mobile
	    },
	    attrs: {
	      "to": "/gefeliciteerd"
	    }
	  }, [_vm._v("OK")]), _vm._v(" "), _c('br'), _c('br')], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "video-container"
	  }, [_c('img', {
	    staticClass: "image-intro",
	    attrs: {
	      "src": "/images/289.jpg",
	      "alt": ""
	    }
	  })])])
	}]}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "splash"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "subtitle"
	  }, [_vm._v(" presenteert ")]), _vm._v(" "), _c('div', {
	    staticClass: "link-image-container"
	  }, [_c('div', {
	    staticClass: "link-image"
	  }, [_c('img', {
	    staticClass: "sound-warning",
	    attrs: {
	      "src": __webpack_require__(99)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "MZBlock",
	    attrs: {
	      "src": __webpack_require__(95)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "link"
	  }, [_c('span', {
	    on: {
	      "click": _vm.start,
	      "touchend": _vm.start
	    }
	  }, [_c('img', {
	    staticClass: "circle",
	    attrs: {
	      "src": __webpack_require__(97)
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "arrow",
	    attrs: {
	      "src": __webpack_require__(98)
	    }
	  })])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "http://om.nl"
	    }
	  }, [_c('img', {
	    staticClass: "omlogo",
	    attrs: {
	      "src": __webpack_require__(96)
	    }
	  })])
	}]}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container main-app"
	  }, [(!_vm.$mobile) ? _c('div', {
	    staticClass: "main-bg-image",
	    style: ({
	      backgroundImage: 'url(' + _vm.thumbnail + ')'
	    })
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "main-bg-cover"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.$mobile && _vm.orientation === 'landscape' || !_vm.$mobile),
	      expression: "$mobile && orientation === 'landscape' || !$mobile"
	    }],
	    staticClass: "desktop-view"
	  }, [_c('transition', {
	    attrs: {
	      "name": "popup",
	      "mode": "out-in"
	    }
	  }, [(_vm.$store.state.carousel.show) ? _c('Carousel') : _vm._e()], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "slide-fade",
	      "mode": "out-in"
	    }
	  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
	    staticClass: "vignette"
	  })], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.$mobile && _vm.orientation === 'portrait'),
	      expression: "$mobile && orientation === 'portrait'"
	    }],
	    staticClass: "mobile-view"
	  }, [_c('div', {
	    staticClass: "mobile-warning"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "timeline",
	    class: {
	      'mobile': _vm.$mobile
	    }
	  }, [_c('div', {
	    staticClass: "border"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "episode-list"
	  }, [_c('v-touch', {
	    staticClass: "copy-01 episodes",
	    attrs: {
	      "tag": "ul"
	    },
	    on: {
	      "swipeleft": _vm.slideRight,
	      "swiperight": _vm.slideLeft
	    }
	  }, _vm._l((_vm.episodes), function(episode, index) {
	    return _c('li', {
	      staticClass: "episode",
	      class: {
	        'locked': episode.locked, 'active': index === _vm.$store.state.game.episode || _vm.$store.state.debugmode, 'complete': _vm.$store.state.game.episodes[index].answers.length === _vm.$store.state.game.episodes[index].actions.length
	      },
	      style: ({
	        width: _vm.width()
	      }),
	      on: {
	        "click": function($event) {
	          _vm.startEpisode(index)
	        }
	      }
	    }, [_c('h4', [_vm._v(_vm._s(episode.title))]), _vm._v(" "), _c('div', {
	      staticClass: "thumbnail-container",
	      class: {
	        'mobile': _vm.$mobile
	      }
	    }, [_c('img', {
	      staticClass: "thumbnail",
	      attrs: {
	        "src": episode.thumbnail
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "state"
	    })])])
	  })), _vm._v(" "), (!_vm.$mobile) ? _c('div', {
	    staticClass: "arrows"
	  }, [_c('div', {
	    staticClass: "arrow-left nav-arrow",
	    class: {
	      'hidden': _vm.activeEp == 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.slideLeft()
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrow-right nav-arrow",
	    class: {
	      'hidden': _vm.activeEp == _vm.episodes.length - 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.slideRight()
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "pagination"
	  }, _vm._l((_vm.episodes), function(episode, index) {
	    return _c('li', {
	      staticClass: "pagination-bullet",
	      class: {
	        'locked': episode.locked, 'active': index === _vm.$store.state.game.episode, 'complete': _vm.$store.state.game.episodes[index].answers.length === _vm.$store.state.game.episodes[index].actions.length, 'mobile': _vm.$mobile
	      }
	    })
	  }))], 1), _vm._v(" "), (!_vm.$mobile) ? _c('div', {
	    staticClass: "points-container"
	  }, [_c('span', [_vm._v(" Totaal aantal punten: ")]), _vm._v(_vm._s(_vm.points) + "\n    ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "congrats",
	    class: {
	      'mobile': _vm.$mobile
	    }
	  }, [_c('div', {
	    staticClass: "half"
	  }, [_c('div', {
	    staticClass: "points-container"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "video-container"
	  }, [(_vm.endtexts[_vm.text].video) ? _c('video', {
	    attrs: {
	      "id": "video",
	      "src": _vm.endtexts[_vm.text].video,
	      "autoplay": ""
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "points count"
	  }, [_c('span', [_vm._v(_vm._s(_vm.points))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "half"
	  }, [_c('div', {
	    staticClass: "text-container"
	  }, [_c('div', {
	    staticClass: "title-01 congrats-title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.endtexts[_vm.text].header)
	    }
	  }, [_vm._v("\n                Gefeliciteerd!\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "title-02 congrats-sub-title"
	  }, [_vm._v("\n                Je hebt " + _vm._s(_vm.points) + " punten gehaald.\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "copy-02 congrats-points-title"
	  }, [_vm._v("\n                Je had " + _vm._s(_vm.maxscore) + " punten kunnen halen.\n            ")])]), _vm._v(" "), (_vm.$mobile) ? _c('a', {
	    staticClass: "button mobile",
	    on: {
	      "click": function($event) {
	        _vm.mobileendtext = true
	      }
	    }
	  }, [_vm._v(" OK")]) : _vm._e()]), _vm._v(" "), (!_vm.$mobile) ? _c('div', {
	    staticClass: "footer"
	  }, [_c('div', {
	    staticClass: "copy-01",
	    domProps: {
	      "innerHTML": _vm._s(_vm.endtexts[_vm.text].text)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('a', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.restart($event)
	      }
	    }
	  }, [_vm._v("Speel opnieuw")]), _vm._v(" "), _c('a', {
	    staticClass: "button",
	    attrs: {
	      "href": "https://www.om.nl",
	      "target": "_BLANK"
	    }
	  }, [_vm._v("Meer informatie")])])]) : _vm._e(), _vm._v(" "), (_vm.$mobile && _vm.mobileendtext) ? _c('div', {
	    staticClass: "mobile-endtext"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "copy-01",
	    domProps: {
	      "innerHTML": _vm._s(_vm.endtexts[_vm.text].text)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('a', {
	    staticClass: "button mobile",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.restart($event)
	      }
	    }
	  }, [_vm._v("Speel opnieuw")]), _vm._v(" "), _c('a', {
	    staticClass: "button mobile",
	    attrs: {
	      "href": "https://www.om.nl",
	      "target": "_BLANK"
	    }
	  }, [_vm._v("Meer informatie")])])])]) : _vm._e(), _vm._v(" "), (!_vm.$mobile || _vm.mobileendtext) ? _c('span', {
	    staticClass: "disclaimer-button",
	    on: {
	      "click": function($event) {
	        _vm.disclaimer = true
	      }
	    }
	  }, [_vm._v("\n        Credits\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.disclaimer),
	      expression: "disclaimer"
	    }],
	    staticClass: "disclaimer"
	  }, [_c('div', {
	    staticClass: "intro-text-container"
	  }, [_vm._m(0), _vm._v(" "), _c('span', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        _vm.disclaimer = false
	      }
	    }
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "intro-text-box"
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Credits")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Ontwerp en realisatie:")]), _c('br'), _vm._v("\n                Openbaar Ministerie in samenwerking met Ijsfontein.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Met dank aan:")]), _c('br'), _vm._v("\n                Officier van justitie Gabriëlle Hoppenbrouwers, Landelijk Team Forensische Opsporing van de Politie, Rechtbank Amsterdam. Beelden: Rechtbank Amsterdam, AVRO/TROS Opsporing Verzocht, Pieter Baan Centrum, Nederlands Forensisch Instituut, Politie en Openbaar Ministerie.\n            ")])
	}]}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(49);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(126)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-822a6350!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Splash.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-822a6350!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Splash.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(__webpack_require__(65)) :
	  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
	  (factory(global.Hammer));
	}(this, (function (Hammer) { 'use strict';
	
	Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;
	
	function assign(target) {
	  var sources = [], len = arguments.length - 1;
	  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
	  for (var i = 0; i < sources.length; i++) {
	    var source = sources[i];
	    var keys = Object.keys(source);
	    for (var i$1 = 0; i$1 < keys.length; i$1++) {
	      var key = keys[i$1];
	      target[key] = source[key];
	    }
	  }
	  return target
	}
	function createProp() {
	  return {
	    type: Object,
	    default: function() { return {} }
	  }
	}
	function capitalize (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	}
	var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
	function guardDirections (options) {
	  var dir = options.direction;
	  if (typeof dir === 'string') {
	    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
	    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
	      options.direction = Hammer[hammerDirection];
	    } else {
	      console.warn('[vue-touch] invalid direction: ' + dir);
	    }
	  }
	  return options
	}
	var config = {
	};
	var customEvents = {
	};
	var gestures = [
	  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
	  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
	  'press','pressup',
	  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
	  'swipe','swipeleft','swiperight','swipeup','swipedown',
	  'tap'
	];
	var gestureMap = {
	  pan: 'pan',
	  panstart: 'pan',
	  panmove: 'pan',
	  panend: 'pan',
	  pancancel: 'pan',
	  panleft: 'pan',
	  panright: 'pan',
	  panup: 'pan',
	  pandown: 'pan',
	  pinch: 'pinch',
	  pinchstart: 'pinch',
	  pinchmove: 'pinch',
	  pinchend: 'pinch',
	  pinchcancel: 'pinch',
	  pinchin: 'pinch',
	  pinchout: 'pinch',
	  press: 'press',
	  pressup: 'press',
	  rotate: 'rotate',
	  rotatestart: 'rotate',
	  rotatemove: 'rotate',
	  rotateend: 'rotate',
	  rotatecancel: 'rotate',
	  swipe: 'swipe',
	  swipeleft: 'swipe',
	  swiperight: 'swipe',
	  swipeup: 'swipe',
	  swipedown: 'swipe',
	  tap: 'tap'
	};
	
	var Component = {
	  props: {
	    options: createProp(),
	    tapOptions: createProp(),
	    panOptions: createProp(),
	    pinchOptions: createProp(),
	    pressOptions: createProp(),
	    rotateOptions: createProp(),
	    swipeOptions: createProp(),
	    tag: { type: String, default: 'div' },
	    enabled: {
	      default: true,
	      type: [Boolean, Object],
	    }
	  },
	  mounted: function mounted() {
	    if (!this.$isServer) {
	      this.hammer = new Hammer.Manager(this.$el, this.options);
	      this.recognizers = {};
	      this.setupBuiltinRecognizers();
	      this.setupCustomRecognizers();
	      this.updateEnabled(this.enabled);
	    }
	  },
	  destroyed: function destroyed() {
	    if (!this.$isServer) {
	      this.hammer.destroy();
	    }
	  },
	  watch: {
	    enabled: {
	      deep: true,
	      handler: function handler() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	        (ref = this).updateEnabled.apply(ref, args);
	        var ref;
	      }
	    }
	  },
	  methods: {
	    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
	      var this$1 = this;
	      for (var i = 0; i < gestures.length; i++) {
	        var gesture = gestures[i];
	        if (this$1._events[gesture]) {
	          var mainGesture = gestureMap[gesture];
	          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
	          this$1.addRecognizer(mainGesture, options);
	          this$1.addEvent(gesture);
	        }
	      }
	    },
	    setupCustomRecognizers: function setupCustomRecognizers() {
	      var this$1 = this;
	      var gestures$$1 = Object.keys(customEvents);
	      for (var i = 0; i < gestures$$1.length; i++) {
	        var gesture = gestures$$1[i];
	        if (this$1._events[gesture]) {
	          var opts = customEvents[gesture];
	          var localCustomOpts = this$1[(gesture + "Options")] || {};
	          var options = assign({}, opts, localCustomOpts);
	          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
	          this$1.addEvent(gesture);
	        }
	      }
	    },
	    addRecognizer: function addRecognizer(gesture, options, ref) {
	      if ( ref === void 0 ) ref = {};
	      var mainGesture = ref.mainGesture;
	      if (!this.recognizers[gesture]) {
	        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
	        this.recognizers[gesture] = recognizer;
	        this.hammer.add(recognizer);
	        recognizer.recognizeWith(this.hammer.recognizers);
	      }
	    },
	    addEvent: function addEvent(gesture) {
	      var this$1 = this;
	      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
	    },
	    updateEnabled: function updateEnabled(newVal, oldVal) {
	      var this$1 = this;
	      if (newVal === true) {
	        this.enableAll();
	      } else if (newVal === false) {
	        this.disableAll();
	      } else if (typeof newVal === 'object') {
	        var keys = Object.keys(newVal);
	        for (var i = 0; i < keys.length; i++) {
	          var event = keys[i];
	          if (this$1.recognizers[event]) {
	            newVal[event]
	              ? this$1.enable(event)
	              : this$1.disable(event);
	          }
	        }
	      }
	    },
	    enable: function enable(r) {
	      var recognizer = this.recognizers[r];
	      if (!recognizer.options.enable) {
	        recognizer.set({ enable: true });
	      }
	    },
	    disable: function disable(r) {
	      var recognizer = this.recognizers[r];
	      if (recognizer.options.enable) {
	        recognizer.set({ enable: false });
	      }
	    },
	    toggle: function toggle(r) {
	      var recognizer = this.recognizers[r];
	      if (recognizer) {
	        recognizer.options.enable
	          ? this.disable(r)
	          : this.enable(r);
	      }
	    },
	    enableAll: function enableAll(r) {
	      this.toggleAll({ enable: true });
	    },
	    disableAll: function disableAll(r) {
	      this.toggleAll({ enable: false });
	    },
	    toggleAll: function toggleAll(ref) {
	      var this$1 = this;
	      var enable = ref.enable;
	      var keys = Object.keys(this.recognizers);
	      for (var i = 0; i < keys.length; i++) {
	        var r = this$1.recognizers[keys[i]];
	        if (r.options.enable !== enable) {
	          r.set({ enable: enable });
	        }
	      }
	    },
	    isEnabled: function isEnabled(r) {
	      return this.recognizers[r] && this.recognizers[r].options.enable
	    }
	  },
	  render: function render(h) {
	    return h(this.tag, {}, this.$slots.default)
	  }
	};
	
	var installed = false;
	var vueTouch = { config: config, customEvents: customEvents };
	vueTouch.install = function install(Vue, opts) {
	  if ( opts === void 0 ) opts = {};
	  var name = opts.name || 'v-touch';
	  Vue.component(name, assign(Component, { name: name }));
	  installed = true;
	}.bind(vueTouch);
	vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
	  if ( options === void 0 ) options = {};
	  if (installed) {
	    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
	    return
	  }
	  options.event = event;
	  customEvents[event] = options;
	  Component.props[(event + "Options")] = {
	    type: Object,
	    default: function default$1() { return {} }
	  };
	}.bind(vueTouch);
	vueTouch.component = Component;
	if (true) {
	  module.exports = vueTouch;
	} else if (typeof define == "function" && define.amd) {
	  define([], function(){ return vueTouch });
	} else if (typeof window !== 'undefined' && window.Vue) {
	  window.VueTouch = vueTouch;
	  Vue.use(vueTouch);
	}
	
	})));
	//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ })
]);


// WEBPACK FOOTER //
// app.js